import React from 'react';
import { createIcon } from '@chakra-ui/react';

// eslint-disable max-len

export const PersonIcon = createIcon({
  displayName: 'PersonIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable max-len
        d="M11.9999 1.52307C13.3999 1.52307 14.6677 2.06293 15.5752 3.04275C16.4939 4.03468 16.942 5.37019 16.836 6.80322C16.6253 9.65861 14.4564 11.9762 11.9999 11.9762C9.54332 11.9762 7.37073 9.65813 7.16327 6.80232C7.0587 5.35603 7.50406 4.01774 8.41708 3.03338L8.39989 3.01745L8.41707 3.03339C9.32032 2.05972 10.5922 1.52307 11.9999 1.52307Z"
        fill="#2B2E2D"
        stroke="#007AFF"
        strokeWidth="0.046875"
      />
      <path
        d="M20.2502 22.4752H20.2499L3.74993 22.4752L3.74963 22.4752C3.53714 22.4779 3.32671 22.4333 3.13365 22.3445C2.94058 22.2557 2.76974 22.125 2.63355 21.9619L2.63353 21.9618C2.33368 21.6034 2.21225 21.1132 2.30206 20.6165L2.30206 20.6165C2.6965 18.4284 3.92733 16.5902 5.86293 15.2993C7.58282 14.1532 9.76212 13.522 11.9999 13.522C14.2377 13.522 16.417 14.1537 18.1369 15.2994C20.0725 16.5897 21.3034 18.4279 21.6978 20.616C21.7876 21.1128 21.6662 21.6029 21.3663 21.9614L21.3663 21.9614C21.2302 22.1246 21.0593 22.2554 20.8663 22.3443C20.6732 22.4332 20.4627 22.4779 20.2502 22.4752Z"
        fill="#2B2E2D"
        stroke="#007AFF"
        strokeWidth="0.046875"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  path: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.6243 16.1083L13.5813 12.0654C14.5547 10.7696 15.0801 9.19235 15.0784 7.57171C15.0784 3.4321 11.7105 0.064209 7.57085 0.064209C3.43124 0.064209 0.0633545 3.4321 0.0633545 7.57171C0.0633545 11.7113 3.43124 15.0792 7.57085 15.0792C9.1915 15.081 10.7687 14.5555 12.0645 13.5822L16.1075 17.6251C16.3121 17.808 16.579 17.9057 16.8534 17.898C17.1278 17.8903 17.3889 17.7779 17.583 17.5838C17.7771 17.3897 17.8895 17.1287 17.8972 16.8543C17.9048 16.5799 17.8072 16.313 17.6243 16.1083ZM2.20835 7.57171C2.20835 6.51111 2.52286 5.47432 3.1121 4.59246C3.70134 3.7106 4.53885 3.02328 5.51871 2.6174C6.49858 2.21153 7.5768 2.10533 8.61703 2.31225C9.65725 2.51916 10.6128 3.02989 11.3627 3.77985C12.1127 4.52981 12.6234 5.48531 12.8303 6.52554C13.0372 7.56576 12.931 8.64398 12.5252 9.62385C12.1193 10.6037 11.432 11.4412 10.5501 12.0305C9.66824 12.6197 8.63146 12.9342 7.57085 12.9342C6.14915 12.9325 4.78617 12.367 3.78088 11.3617C2.77558 10.3564 2.21006 8.99341 2.20835 7.57171Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 18 18',
});

export const ScanBarcodeIcon = createIcon({
  displayName: 'ScanBarcodeIcon',
  path: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5001 17.2017L18.0096 17.1875C18.3381 17.186 18.6528 17.0549 18.8851 16.8225C19.1174 16.5902 19.2486 16.2755 19.2501 15.947V6.05301C19.2486 5.72446 19.1174 5.40978 18.8851 5.17746C18.6528 4.94514 18.3381 4.81397 18.0096 4.8125L16.5001 4.82668"
        stroke="#007AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.50009 4.8125L3.91884 4.82668C3.2365 4.82668 2.75009 5.38527 2.75009 6.06719V15.9616C2.75009 16.6435 3.2365 17.2017 3.91884 17.2017L5.50009 17.1875"
        stroke="#007AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5001 8.25098V13.751"
        stroke="#007AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.7501 6.875V15.125" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 7.5625V14.4375" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.25006 6.875V15.125" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.49997 8.25098V13.751"
        stroke="#007AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 22 22',
});

export const SignalIcon = createIcon({
  displayName: 'SignalIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5949 15.0002C14.6081 14.1231 13.3338 13.6387 12.0136 13.6387C10.6934 13.6387 9.41912 14.1231 8.43237 15.0002"
        stroke="#2B2E2D"
        strokeWidth="2.3"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18.4565 12.1409C16.7088 10.5067 14.4056 9.59766 12.013 9.59766C9.62041 9.59766 7.31719 10.5067 5.56958 12.1409"
        stroke="#2B2E2D"
        strokeWidth="2.3"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21.0001 8.9787C18.5267 6.77217 15.3279 5.55273 12.0132 5.55273C8.69861 5.55273 5.49982 6.77217 3.02637 8.9787"
        stroke="#2B2E2D"
        strokeWidth="2.3"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.094 18.0007L12.0001 20.2976L9.92163 18.0007C10.1706 17.6865 10.4874 17.4327 10.8483 17.2583C11.2092 17.0838 11.6048 16.9932 12.0057 16.9932C12.4065 16.9932 12.8022 17.0838 13.1631 17.2583C13.524 17.4327 13.8408 17.6865 14.0898 18.0007H14.094Z"
        fill="#2B2E2D"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const RefreshIcon = createIcon({
  displayName: 'RefreshIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7333 2C10.3802 1.99966 9.0432 2.30121 7.81512 2.88375C6.58703 3.46629 5.49725 4.31585 4.62138 5.3735L3.32831 4.19375C3.19119 4.07043 3.02237 3.99015 2.84199 3.96249C2.6616 3.93483 2.47727 3.96095 2.31097 4.03775C2.14415 4.11465 2.0025 4.23925 1.903 4.39662C1.80351 4.55399 1.75038 4.73745 1.75 4.925V8.825C1.75 9.08359 1.85017 9.33158 2.02848 9.51443C2.20679 9.69728 2.44862 9.8 2.70079 9.8H6.97934C7.17087 9.79942 7.35776 9.73954 7.51554 9.6282C7.67332 9.51685 7.79463 9.35924 7.86358 9.176C7.93367 8.99031 7.94665 8.78706 7.90075 8.59359C7.85486 8.40011 7.7523 8.22568 7.60686 8.09375L6.03806 6.6605C6.73984 5.81085 7.61373 5.12821 8.59894 4.66011C9.58414 4.19201 10.657 3.94969 11.7428 3.95C13.1372 3.94977 14.5048 4.3426 15.6962 5.08557C16.8876 5.82853 17.8569 6.89303 18.4982 8.16273C19.1395 9.43243 19.4281 10.8585 19.3324 12.285C19.2368 13.7115 18.7606 15.0837 17.9559 16.2514C17.1512 17.4192 16.0489 18.3376 14.7696 18.9064C13.4903 19.4752 12.0831 19.6724 10.7018 19.4764C9.32059 19.2805 8.01845 18.699 6.93771 17.7955C5.85697 16.892 5.03922 15.7012 4.57384 14.3533C4.49063 14.1089 4.31616 13.9084 4.08882 13.796C3.86148 13.6835 3.59988 13.6683 3.36159 13.7536C3.12329 13.839 2.92781 14.0179 2.81815 14.251C2.70849 14.4841 2.69364 14.7524 2.77685 14.9968C3.35748 16.6827 4.37903 18.1725 5.72978 19.3032C7.08053 20.4338 8.70846 21.1618 10.4355 21.4075C12.1626 21.6532 13.9223 21.4072 15.5222 20.6963C17.1221 19.9854 18.5006 18.8371 19.5068 17.3769C20.5131 15.9167 21.1084 14.2008 21.2277 12.417C21.347 10.6332 20.9856 8.85006 20.1832 7.26266C19.3807 5.67527 18.168 4.34473 16.6777 3.41657C15.1874 2.4884 13.4769 1.99835 11.7333 2Z"
        fill="#464646"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const UninitializedCircuitIcon = createIcon({
  displayName: 'UninitializedCircuitIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11.75" cy="11.75" r="9.75" fill="#9BA0A1" />
      <path
        d="M17.8405 8.0096L15.9855 6.15022C15.7396 5.90577 15.407 5.76855 15.0602 5.76855C14.7135 5.76855 14.3808 5.90577 14.1349 6.15022L11.4049 8.85397L12.0218 9.47522L14.7474 6.77147C14.7881 6.73046 14.8365 6.69792 14.8898 6.67571C14.9431 6.65349 15.0003 6.64206 15.058 6.64206C15.1158 6.64206 15.173 6.65349 15.2263 6.67571C15.2796 6.69792 15.328 6.73046 15.3687 6.77147L17.2237 8.62647C17.2647 8.66714 17.2972 8.71553 17.3194 8.76884C17.3416 8.82216 17.3531 8.87934 17.3531 8.9371C17.3531 8.99485 17.3416 9.05203 17.3194 9.10535C17.2972 9.15866 17.2647 9.20705 17.2237 9.24772L14.4937 11.9515L15.1105 12.5727L17.8362 9.86897C17.9606 9.74795 18.0592 9.603 18.1261 9.44285C18.1931 9.2827 18.2269 9.11066 18.2255 8.9371C18.2252 8.58912 18.0868 8.2555 17.8405 8.0096Z"
        fill="white"
      />
      <path
        d="M9.24807 17.2011C9.1661 17.2826 9.05522 17.3284 8.93964 17.3284C8.82405 17.3284 8.71317 17.2826 8.6312 17.2011L6.7762 15.3418C6.73486 15.3012 6.70197 15.2529 6.67944 15.1996C6.65691 15.1463 6.64519 15.089 6.64495 15.0311C6.64519 14.9732 6.65691 14.916 6.67944 14.8627C6.70197 14.8093 6.73486 14.761 6.7762 14.7205L9.50182 11.9993L8.88495 11.3955L6.15932 14.0993C6.0363 14.2213 5.93866 14.3664 5.87203 14.5264C5.80539 14.6863 5.77109 14.8579 5.77109 15.0311C5.77109 15.2044 5.80539 15.3759 5.87203 15.5359C5.93866 15.6958 6.0363 15.841 6.15932 15.963L8.00995 17.818C8.25657 18.0626 8.5901 18.1995 8.93745 18.1986C9.28266 18.1995 9.61432 18.0643 9.86057 17.8224L12.5862 15.1143L11.9737 14.493L9.24807 17.2011Z"
        fill="white"
      />
      <path d="M10.6875 7.1875H9.8125V9.375H10.6875V7.1875Z" fill="white" />
      <path d="M9.375 9.8125H7.1875V10.6875H9.375V9.8125Z" fill="white" />
      <path d="M14.1875 14.625H13.3125V16.8125H14.1875V14.625Z" fill="white" />
      <path d="M16.8125 13.3125H14.625V14.1875H16.8125V13.3125Z" fill="white" />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const SkippedTestIcon = createIcon({
  displayName: 'SkippedTestIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61521 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61521 21.75 12 21.75ZM11.4265 16.0022C11.117 15.6491 11.1523 15.1121 11.5054 14.8027L13.8653 12.734L7.33052 12.734C6.86108 12.734 6.48052 12.3534 6.48052 11.884C6.48052 11.4145 6.86108 11.034 7.33052 11.034H13.8653L11.5054 8.9653C11.1523 8.65585 11.117 8.11882 11.4265 7.76581C11.7359 7.4128 12.273 7.37748 12.626 7.68693L16.6847 11.2448C16.8688 11.4062 16.9744 11.6391 16.9744 11.884C16.9744 12.1288 16.8688 12.3618 16.6847 12.5232L12.626 16.081C12.273 16.3905 11.7359 16.3552 11.4265 16.0022Z"
        fill="#FFC634"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const CloseIcon = createIcon({
  displayName: 'CloseIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.25 17.2498L6.75 6.74979"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 6.74979L6.75 17.2498"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const EnvelopeIcon = createIcon({
  displayName: 'EnvelopeIcon',
  path: (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8129 2.05L17.1004 1.33749L10.5004 7.9375C9.67539 8.7625 8.28789 8.7625 7.46289 7.9375L0.862891 1.375L0.150391 2.08749L5.06289 7L0.150391 11.9125L0.862891 12.625L5.77539 7.71249L6.75039 8.6875C7.35039 9.2875 8.13789 9.625 8.96289 9.625C9.78789 9.625 10.5754 9.2875 11.1754 8.6875L12.1504 7.71249L17.0629 12.625L17.7754 11.9125L12.8629 7L17.8129 2.05Z"
        fill="#007AFF"
      />
      <path
        d="M16.4256 13.9H1.61309C0.750588 13.9 0.0380859 13.1875 0.0380859 12.325V1.75C0.0380859 0.887502 0.750588 0.175003 1.61309 0.175003H16.4256C17.2881 0.175003 18.0006 0.887502 18.0006 1.75V12.325C18.0006 13.1875 17.2881 13.9 16.4256 13.9ZM1.57559 1.1875C1.27559 1.1875 1.05059 1.4125 1.05059 1.7125V12.2875C1.05059 12.5875 1.27559 12.8125 1.57559 12.8125H16.3881C16.6881 12.8125 16.9131 12.5875 16.9131 12.2875V1.7125C16.9131 1.4125 16.6881 1.1875 16.3881 1.1875H1.57559Z"
        fill="#007AFF"
      />
    </svg>
  ),
  viewBox: '0 0 18 14',
});

export const PolarityNormalIcon = createIcon({
  displayName: 'PolarityNormalIcon',
  path: (
    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23499 18C3.41221 18 3.55587 17.8672 3.55587 17.7033V13.3983H5.37367C5.55089 13.3983 5.69455 13.2654 5.69455 13.1016C5.69455 12.9377 5.55089 12.8049 5.37367 12.8049H3.55587L3.55587 9.39674H5.37367C5.55089 9.39674 5.69455 9.2639 5.69455 9.10004C5.69455 8.93617 5.55089 8.80334 5.37367 8.80334H3.55587L3.55587 5.39523H5.37367C5.55089 5.39523 5.69455 5.26239 5.69455 5.09852C5.69455 4.93466 5.55089 4.80182 5.37367 4.80182H3.55587V0.296703C3.55587 0.132838 3.41221 -1.43256e-08 3.23499 0C3.05777 1.43255e-08 2.91411 0.132838 2.91411 0.296703V4.80182H1.73792C1.68153 4.80182 1.62614 4.81556 1.57732 4.84166C1.03452 5.13182 0.354923 5.70944 0.152875 6.5118C-0.0403812 7.27924 0.222902 8.1627 1.24353 9.08292C0.743376 9.47194 0.408662 9.86602 0.213197 10.2599C-0.0217545 10.7334 -0.0474224 11.191 0.0628786 11.6067C0.278612 12.4197 1.00079 13.0349 1.57141 13.3552C1.62161 13.3834 1.6792 13.3983 1.73792 13.3983H2.91411V17.7033C2.91411 17.8672 3.05778 18 3.23499 18ZM2.91411 12.8049H1.8302C1.35133 12.5179 0.836866 12.0333 0.686155 11.4653C0.609322 11.1757 0.623754 10.8555 0.796487 10.5074C0.963426 10.171 1.28528 9.795 1.84545 9.39674H2.91411V12.8049ZM2.91411 8.80334H1.85932C0.799468 7.92147 0.642386 7.18457 0.777916 6.64637C0.917511 6.09202 1.39025 5.64734 1.82687 5.39523H2.91411V8.80334Z"
        fill="currentColor"
      />
      <path
        d="M8.95793 4.72045C9.53589 4.6049 9.96893 4.12943 9.96893 3.56044C9.96893 2.90498 9.39428 2.37363 8.68541 2.37363C7.97654 2.37363 7.40189 2.90498 7.40189 3.56044C7.40189 4.09722 7.78728 4.55076 8.31617 4.69741L8.31617 15.1079L6.82188 13.7262C6.69657 13.6103 6.4934 13.6103 6.36808 13.7262C6.24277 13.842 6.24277 14.0299 6.36808 14.1458L8.41015 16.034C8.53547 16.1498 8.73864 16.1498 8.86395 16.034L10.906 14.1458C11.0313 14.0299 11.0313 13.842 10.906 13.7262C10.7807 13.6103 10.5775 13.6103 10.4522 13.7262L8.95793 15.1079V4.72045Z"
        fill="currentColor"
      />
      <path
        d="M10.0834 3.60002C10.0834 4.3456 9.46776 4.95002 8.70837 4.95002C7.94898 4.95002 7.33337 4.3456 7.33337 3.60002C7.33337 2.85443 7.94898 2.25002 8.70837 2.25002C9.46776 2.25002 10.0834 2.85443 10.0834 3.60002Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 11 18',
});

export const PolarityReverseIcon = createIcon({
  displayName: 'PolarityReverseIcon',
  path: (
    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.765 2.82812e-07C7.58779 2.98305e-07 7.44412 0.132838 7.44412 0.296702L7.44412 4.60174L5.62633 4.60174C5.44911 4.60174 5.30545 4.73458 5.30545 4.89844C5.30545 5.06231 5.44911 5.19515 5.62633 5.19515L7.44412 5.19515L7.44413 8.60326L5.62633 8.60326C5.44911 8.60326 5.30545 8.7361 5.30545 8.89996C5.30545 9.06383 5.44911 9.19667 5.62633 9.19667L7.44413 9.19667L7.44413 12.6048L5.62633 12.6048C5.44911 12.6048 5.30545 12.7376 5.30545 12.9015C5.30545 13.0653 5.44911 13.1982 5.62633 13.1982L7.44413 13.1982L7.44413 17.7033C7.44413 17.8672 7.58779 18 7.76501 18C7.94223 18 8.08589 17.8672 8.08589 17.7033L8.08589 13.1982L9.26208 13.1982C9.31847 13.1982 9.37386 13.1844 9.42268 13.1583C9.96548 12.8682 10.6451 12.2906 10.8471 11.4882C11.0404 10.7208 10.7771 9.8373 9.75647 8.91708C10.2566 8.52806 10.5913 8.13398 10.7868 7.74009C11.0218 7.26662 11.0474 6.80904 10.9371 6.39334C10.7214 5.58029 9.99921 4.96511 9.42859 4.64482C9.37839 4.61664 9.3208 4.60174 9.26208 4.60174L8.08589 4.60174L8.08588 0.296702C8.08588 0.132838 7.94222 2.67319e-07 7.765 2.82812e-07ZM8.08589 5.19515L9.1698 5.19515C9.64867 5.4821 10.1631 5.96674 10.3138 6.53474C10.3907 6.8243 10.3762 7.14452 10.2035 7.49261C10.0366 7.82903 9.71472 8.205 9.15455 8.60326L8.08589 8.60326L8.08589 5.19515ZM8.08589 9.19667L9.14068 9.19666C10.2005 10.0785 10.3576 10.8154 10.2221 11.3536C10.0825 11.908 9.60975 12.3527 9.17313 12.6048L8.08589 12.6048L8.08589 9.19667Z"
        fill="currentColor"
      />
      <path
        d="M2.04207 13.2796C1.46411 13.3951 1.03107 13.8706 1.03107 14.4396C1.03107 15.095 1.60572 15.6264 2.31459 15.6264C3.02346 15.6264 3.59811 15.095 3.59811 14.4396C3.59811 13.9028 3.21272 13.4492 2.68383 13.3026L2.68383 2.89213L4.17812 4.27383C4.30343 4.3897 4.5066 4.3897 4.63191 4.27383C4.75723 4.15796 4.75723 3.9701 4.63191 3.85423L2.58985 1.96602C2.46453 1.85015 2.26136 1.85015 2.13605 1.96602L0.0939824 3.85423C-0.0313294 3.9701 -0.0313294 4.15796 0.0939825 4.27383C0.219294 4.3897 0.422464 4.3897 0.547776 4.27383L2.04207 2.89213L2.04207 13.2796Z"
        fill="currentColor"
      />
      <path
        d="M0.916632 14.4C0.916632 13.6544 1.53224 13.05 2.29163 13.05C3.05102 13.05 3.66663 13.6544 3.66663 14.4C3.66663 15.1456 3.05102 15.75 2.29163 15.75C1.53224 15.75 0.916632 15.1456 0.916632 14.4Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 11 18',
});

export const CustomInfoIcon = createIcon({
  displayName: 'CustomInfoIcon',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4999 3.00244C6.25371 3.00244 1.99988 7.25627 1.99988 12.5024C1.99988 17.7486 6.25371 22.0024 11.4999 22.0024C16.746 22.0024 20.9999 17.7486 20.9999 12.5024C20.9999 7.25627 16.746 3.00244 11.4999 3.00244Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.3125 10.3132H11.8125V15.7507"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.74988 15.9377H13.8749"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.6249 6.09521C11.3838 6.09521 11.1482 6.16669 10.9478 6.30061C10.7474 6.43453 10.5911 6.62487 10.4989 6.84757C10.4067 7.07027 10.3825 7.31532 10.4295 7.55173C10.4766 7.78814 10.5926 8.00531 10.7631 8.17575C10.9335 8.3462 11.1507 8.46227 11.3871 8.5093C11.6235 8.55632 11.8686 8.53219 12.0913 8.43994C12.314 8.3477 12.5043 8.19149 12.6382 7.99106C12.7722 7.79064 12.8436 7.55501 12.8436 7.31396C12.8436 6.99073 12.7152 6.68074 12.4867 6.45218C12.2581 6.22362 11.9481 6.09521 11.6249 6.09521Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const SupportIcon = createIcon({
  displayName: 'SupportIcon',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4363_46135)">
        <path
          d="M17.6001 7.99995C17.6001 7.55835 17.2417 7.19995 16.8001 7.19995C16.3585 7.19995 16.0001 7.55835 16.0001 7.99995C16.0001 8.19035 16.0001 13.8096 16.0001 14C16.0001 14.4416 16.3585 14.8 16.8001 14.8C17.2417 14.8 17.6001 14.4416 17.6001 14C17.6001 13.8096 17.6001 8.19035 17.6001 7.99995Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M11.1999 18.7999C11.6415 18.7999 11.9999 18.4415 11.9999 18C11.9999 17.5584 11.6415 17.2 11.1999 17.2C11.0095 17.2 9.3903 17.2 9.1999 17.2C8.7583 17.2 8.3999 17.5584 8.3999 18C8.3999 18.4415 8.7583 18.7999 9.1999 18.7999C9.3903 18.7999 11.0095 18.7999 11.1999 18.7999Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M3.19995 7.60005C3.19995 3.84445 6.24435 0.800049 9.99995 0.800049C13.7556 0.800049 16.8 3.84445 16.8 7.60005"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M17.6 8C18.7048 8 19.6 9.3428 19.6 11C19.6 12.6564 18.7048 14 17.6 14"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M2.40002 7.99995C2.40002 7.55835 2.75842 7.19995 3.20002 7.19995C3.64162 7.19995 4.00002 7.55835 4.00002 7.99995C4.00002 8.19035 4.00002 13.8096 4.00002 14C4.00002 14.4416 3.64162 14.8 3.20002 14.8C2.75842 14.8 2.40002 14.4416 2.40002 14C2.40002 13.8096 2.40002 8.19035 2.40002 7.99995Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M2.40002 8C1.29562 8 0.400024 9.3428 0.400024 11C0.400024 12.6564 1.29562 14 2.40002 14"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M16.7999 14.8C16.7999 16.8 15.5999 18 13.5999 18H11.9999"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_4363_46135">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 20 20',
});

// Navigation icons
export const AccountIconActive = createIcon({
  displayName: 'AccountIconActive',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.0769 12C23.0769 5.8923 18.1082 0.923096 12 0.923096C5.89185 0.923096 0.923096 5.8923 0.923096 12C0.923096 15.1233 2.2276 17.9434 4.31415 19.959C4.363 20.0226 4.42086 20.0742 4.48858 20.1176C6.46511 21.9479 9.09997 23.0769 12 23.0769C14.9001 23.0769 17.5349 21.9479 19.5115 20.1176C19.5792 20.0742 19.637 20.0226 19.6859 19.959C21.7724 17.9434 23.0769 15.1233 23.0769 12ZM8.33205 9.7667C8.33205 7.74792 9.97718 6.10549 12 6.10549C14.0229 6.10549 15.668 7.74792 15.668 9.7667C15.668 11.7855 14.0229 13.4279 12 13.4279C9.97718 13.4279 8.33205 11.7855 8.33205 9.7667ZM5.56688 19.2295C5.775 16.6911 8.46682 14.8125 12 14.8125C15.5332 14.8125 18.225 16.6911 18.4332 19.2295C16.7198 20.7559 14.4699 21.6923 12 21.6923C9.53012 21.6923 7.28024 20.7559 5.56688 19.2295Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const AccountIconInactive = createIcon({
  displayName: 'AccountIconInactive',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.0769 12C23.0769 5.8923 18.1082 0.923096 12 0.923096C5.89185 0.923096 0.923096 5.8923 0.923096 12C0.923096 15.1233 2.2276 17.9434 4.31415 19.959C4.363 20.0226 4.42086 20.0742 4.48858 20.1176C6.46511 21.9479 9.09997 23.0769 12 23.0769C14.9001 23.0769 17.5349 21.9479 19.5115 20.1176C19.5792 20.0742 19.637 20.0226 19.6859 19.959C21.7724 17.9434 23.0769 15.1233 23.0769 12ZM12 2.30771C17.3447 2.30771 21.6923 6.65582 21.6923 12C21.6923 14.2661 20.9047 16.3485 19.5967 18.0008C18.9962 16.0643 17.282 14.5484 14.9553 13.8508C16.2233 12.9332 17.0526 11.4466 17.0526 9.7667C17.0526 6.98439 14.7864 4.72087 12 4.72087C9.21366 4.72087 6.94743 6.98439 6.94743 9.7667C6.94743 11.4466 7.77676 12.9332 9.0447 13.8508C6.71807 14.5484 5.00381 16.0643 4.40334 18.0008C3.09535 16.3485 2.30771 14.2661 2.30771 12C2.30771 6.65582 6.65537 2.30771 12 2.30771ZM8.33205 9.7667C8.33205 7.74792 9.97718 6.10549 12 6.10549C14.0229 6.10549 15.668 7.74792 15.668 9.7667C15.668 11.7855 14.0229 13.4279 12 13.4279C9.97718 13.4279 8.33205 11.7855 8.33205 9.7667ZM5.56688 19.2295C5.775 16.6911 8.46682 14.8125 12 14.8125C15.5332 14.8125 18.225 16.6911 18.4332 19.2295C16.7198 20.7559 14.4699 21.6923 12 21.6923C9.53012 21.6923 7.28024 20.7559 5.56688 19.2295Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const DashboardIconActive = createIcon({
  displayName: 'DashboardIconActive',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.09847 16.734C2.95369 16.7341 2.81199 16.6922 2.69047 16.6136C2.56895 16.5349 2.4728 16.4227 2.41362 16.2906C1.69759 14.6914 1.39313 12.9385 1.52797 11.1916C1.66281 9.44461 2.23268 7.75919 3.18564 6.28886C4.1386 4.81853 5.44435 3.61006 6.98391 2.77355C8.52347 1.93704 10.2479 1.4991 12 1.49963C12.1989 1.49963 12.3897 1.57865 12.5304 1.7193C12.671 1.85996 12.75 2.05072 12.75 2.24963V11.9996C12.7501 12.1445 12.7082 12.2862 12.6294 12.4077C12.5506 12.5292 12.4383 12.6254 12.3061 12.6845L3.40456 16.6665C3.30845 16.7104 3.20412 16.7334 3.09847 16.734V16.734Z"
        fill="currentColor"
      />
      <path
        d="M14.6996 3.19547C14.6452 3.18444 14.5891 3.18562 14.5352 3.19892C14.4814 3.21221 14.4311 3.2373 14.3881 3.27236C14.3451 3.30743 14.3104 3.3516 14.2866 3.40169C14.2627 3.45178 14.2502 3.50655 14.2501 3.56203V11.9995C14.2497 12.4338 14.1239 12.8587 13.8877 13.2231C13.6515 13.5875 13.3151 13.8759 12.9188 14.0536L4.83432 17.6714C4.78421 17.6938 4.73962 17.7269 4.70369 17.7684C4.66777 17.8098 4.64139 17.8587 4.62642 17.9115C4.61144 17.9643 4.60823 18.0197 4.61702 18.0739C4.62581 18.1281 4.64639 18.1796 4.67729 18.225C5.296 19.135 6.06399 19.9339 6.94885 20.588C8.62533 21.8351 10.6606 22.5058 12.7501 22.4995C18.1262 22.4995 22.5001 18.1256 22.5001 12.7495C22.5001 8.04094 19.1448 4.10109 14.6996 3.19547Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const DashboardIconInactive = createIcon({
  displayName: 'DashboardIconInactive',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0023 3.77928C12.2489 3.75897 12.4981 3.74881 12.75 3.74881C17.7187 3.74881 21.75 7.78006 21.75 12.7488C21.75 17.7176 17.7187 21.7488 12.75 21.7488C10.8433 21.7487 8.98593 21.1434 7.44535 20.0201C5.90476 18.8967 4.76053 17.3133 4.17749 15.498"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.9999 2.24969C6.61492 2.24969 2.24992 6.61469 2.24992 11.9997C2.24787 13.3728 2.53688 14.7308 3.09789 15.9841L11.9999 11.9997V2.24969Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const SitesIconActive = createIcon({
  displayName: 'SitesIconActive',
  path: (
    <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8137 9.51968L9.43139 4.33356C8.64945 3.69871 7.51502 3.69871 6.73308 4.33356L0.351659 9.51883C0.127645 9.70058 0 9.9694 0 10.2568L0 20.0145C0 20.5386 0.426893 20.9697 0.951 20.9697H5.23008C5.75419 20.9697 6.18108 20.5386 6.18108 20.0145L6.18108 13.8385H9.98424V20.0145C9.98424 20.5386 10.4111 20.9697 10.9352 20.9697H15.2143C15.7384 20.9697 16.1653 20.5386 16.1653 20.0145L16.1653 10.2568C16.1645 9.9694 16.0368 9.70058 15.8137 9.51968Z"
        fill="currentColor"
      />
      <path
        d="M21.2661 0.476134L27.6483 5.66226C27.8715 5.84316 27.9991 6.11197 28 6.39939V16.1571C28 16.6812 27.5731 17.1123 27.049 17.1123H22.7699C22.2458 17.1123 21.8189 16.6812 21.8189 16.1571V9.98107H18.0157L18.0157 16.1571C18.0157 16.6812 17.5889 17.1123 17.0647 17.1123L16.9067 9.35212L12.2573 5.54812L18.5678 0.476134C19.3497 -0.158711 20.4841 -0.158711 21.2661 0.476134Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 28 21',
});

export const SitesIconInactive = createIcon({
  displayName: 'SitesIconInactive',
  path: (
    <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3407 10.1018L15.3414 10.1023C15.3879 10.1401 15.4149 10.1948 15.4153 10.2584V20.0145C15.4153 20.1288 15.3199 20.2198 15.2143 20.2198H10.9352C10.8297 20.2198 10.7342 20.1288 10.7342 20.0145V13.8385V13.0885H9.98424H6.18108H5.43108V13.8385L5.43108 20.0145C5.43108 20.1288 5.33565 20.2198 5.23008 20.2198H0.951C0.845425 20.2198 0.75 20.1288 0.75 20.0145L0.75 10.2568C0.75 10.1952 0.77594 10.1404 0.82419 10.1013L0.824624 10.1009L7.20581 4.91585C7.20585 4.91582 7.20588 4.91579 7.20591 4.91577C7.20596 4.91573 7.206 4.91569 7.20605 4.91566C7.7125 4.50465 8.45227 4.50472 8.95866 4.91585L15.3407 10.1018Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17.3821 8.77166L13.4485 5.55331L19.0381 1.06072L19.0381 1.06072L19.041 1.05839C19.5474 0.647268 20.2871 0.647202 20.7936 1.0582C20.7937 1.05826 20.7937 1.05833 20.7938 1.05839L27.1758 6.24432L27.1765 6.24488C27.2231 6.2826 27.2501 6.33737 27.2505 6.40094V16.1571C27.2505 16.2713 27.1551 16.3623 27.0495 16.3623H22.7704C22.6648 16.3623 22.5694 16.2713 22.5694 16.1571V9.98107V9.23107H21.8194H18.0162H17.6548L17.6499 8.99082L17.3821 8.77166Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
  viewBox: '0 0 28 21',
});

export const LogoutIcon = createIcon({
  displayName: 'Logout',
  path: (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.83268 23.6667C1.52326 23.6667 1.22652 23.5438 1.00772 23.325C0.788932 23.1062 0.666016 22.8094 0.666016 22.5V1.50001C0.666016 1.19059 0.788932 0.893845 1.00772 0.675052C1.22652 0.45626 1.52326 0.333344 1.83268 0.333344H18.166C18.4754 0.333344 18.7722 0.45626 18.991 0.675052C19.2098 0.893845 19.3327 1.19059 19.3327 1.50001V5.00001H16.9993V2.66668H2.99935V21.3333H16.9993V19H19.3327V22.5C19.3327 22.8094 19.2098 23.1062 18.991 23.325C18.7722 23.5438 18.4754 23.6667 18.166 23.6667H1.83268ZM16.9993 16.6667V13.1667H8.83268V10.8333H16.9993V7.33334L22.8327 12L16.9993 16.6667Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 23 24',
});

export const EyeIcon = createIcon({
  displayName: 'EyeIcon',
  path: (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9841 1.25015C8.33067 1.25015 4.58301 3.36468 1.6327 7.59374C1.54849 7.71579 1.50234 7.86005 1.50009 8.00831C1.49783 8.15657 1.53958 8.30217 1.62004 8.42671C3.88692 11.9751 7.58442 14.7501 11.9841 14.7501C16.336 14.7501 20.1094 11.9667 22.3805 8.41031C22.4591 8.2882 22.5009 8.14606 22.5009 8.00085C22.5009 7.85565 22.4591 7.7135 22.3805 7.5914C20.1043 4.07578 16.3032 1.25015 11.9841 1.25015Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 11.7499C14.0709 11.7499 15.7499 10.0709 15.7499 7.99988C15.7499 5.92881 14.0709 4.24988 11.9999 4.24988C9.92881 4.24988 8.24988 5.92881 8.24988 7.99988C8.24988 10.0709 9.92881 11.7499 11.9999 11.7499Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  viewBox: '0 0 24 16',
});

export const CortexCellIcon = createIcon({
  displayName: 'CortexCellIcon',
  path: (
    <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6966 6.21417H1.19775C1.00567 6.21417 0.85 6.36984 0.85 6.56192V13.8178C0.85 14.0099 1.00567 14.1656 1.19775 14.1656H11.6966C11.8887 14.1656 12.0444 14.0099 12.0444 13.8178V6.56192C12.0444 6.36984 11.8887 6.21417 11.6966 6.21417ZM11.3489 13.4701H1.54551V6.90968H11.3489V13.4701Z"
        fill="#2B2E2D"
        stroke="#2B2E2D"
        strokeWidth="0.3"
      />
      <path
        d="M6.37289 11.7463C7.55989 11.7463 8.52214 10.7841 8.52214 9.59707C8.52214 8.41007 7.55989 7.44781 6.37289 7.44781C5.18589 7.44781 4.22363 8.41007 4.22363 9.59707C4.22363 10.7841 5.18589 11.7463 6.37289 11.7463Z"
        fill="#2B2E2D"
      />
      <path d="M6.62859 8.40405H7.50859L7.13264 10.7829H6.25098L6.62859 8.40405Z" fill="white" />
      <path d="M5.55759 8.40419H6.43925L6.0633 10.783H5.18164L5.55759 8.40419Z" fill="white" />
      <path
        d="M3.64911 11.8447C3.29125 11.8447 3 12.1359 3 12.4938C3 12.8517 3.29117 13.1429 3.64911 13.1429C4.00704 13.1429 4.29822 12.8517 4.29822 12.4938C4.29814 12.1359 4.00697 11.8447 3.64911 11.8447ZM3.64911 12.7474C3.50926 12.7474 3.39551 12.6337 3.39551 12.4938C3.39551 12.354 3.50926 12.2402 3.64911 12.2402C3.78896 12.2402 3.90271 12.354 3.90271 12.4938C3.90263 12.6337 3.78888 12.7474 3.64911 12.7474Z"
        fill="#2B2E2D"
      />
      <path
        d="M5.51434 11.8447C5.15649 11.8447 4.86523 12.1359 4.86523 12.4938C4.86523 12.8517 5.15641 13.1429 5.51434 13.1429C5.87228 13.1429 6.16345 12.8517 6.16345 12.4938C6.16345 12.1359 5.87228 11.8447 5.51434 11.8447ZM5.51434 12.7474C5.37449 12.7474 5.26074 12.6337 5.26074 12.4938C5.26074 12.354 5.37449 12.2402 5.51434 12.2402C5.6542 12.2402 5.76794 12.354 5.76794 12.4938C5.76794 12.6337 5.6542 12.7474 5.51434 12.7474Z"
        fill="#2B2E2D"
      />
      <path
        d="M7.38055 11.8447C7.02262 11.8447 6.73145 12.1359 6.73145 12.4938C6.73145 12.8517 7.02262 13.1429 7.38055 13.1429C7.73841 13.1429 8.02966 12.8517 8.02966 12.4938C8.02966 12.1359 7.73841 11.8447 7.38055 11.8447ZM7.38055 12.7474C7.2407 12.7474 7.12695 12.6337 7.12695 12.4938C7.12695 12.354 7.2407 12.2402 7.38055 12.2402C7.52041 12.2402 7.63415 12.354 7.63415 12.4938C7.63415 12.6337 7.52041 12.7474 7.38055 12.7474Z"
        fill="#2B2E2D"
      />
      <path
        d="M9.24579 11.8447C8.88793 11.8447 8.59668 12.1359 8.59668 12.4938C8.59668 12.8517 8.88785 13.1429 9.24579 13.1429C9.60372 13.1429 9.8949 12.8517 9.8949 12.4938C9.8949 12.1359 9.60372 11.8447 9.24579 11.8447ZM9.24579 12.7474C9.10594 12.7474 8.99219 12.6337 8.99219 12.4938C8.99219 12.354 9.10594 12.2402 9.24579 12.2402C9.38564 12.2402 9.49939 12.354 9.49939 12.4938C9.49939 12.6337 9.38564 12.7474 9.24579 12.7474Z"
        fill="#2B2E2D"
      />
      <path
        d="M2.18338 6.15C2.26174 6.15 2.34612 6.12726 2.41291 6.0677C2.4823 6.00581 2.51677 5.91825 2.51677 5.82182V1.58299H10.4832V5.82182C10.4832 5.91825 10.5177 6.0058 10.5871 6.0677C10.6539 6.12726 10.7383 6.15 10.8166 6.15C10.895 6.15 10.9794 6.12726 11.0461 6.0677C11.1155 6.00581 11.15 5.91825 11.15 5.82182V1.2165C11.15 1.03837 11.0231 0.85 10.8166 0.85H2.18338C1.97686 0.85 1.85 1.03837 1.85 1.2165V5.82182C1.85 5.91825 1.88447 6.00581 1.95386 6.0677C2.02064 6.12726 2.10502 6.15 2.18338 6.15Z"
        fill="#2B2E2D"
        stroke="#2B2E2D"
        strokeWidth="0.3"
      />
      <path
        d="M1.79248 14.2827C1.86923 14.2827 1.95362 14.3013 2.02274 14.3535C2.09703 14.4096 2.14024 14.4951 2.14024 14.5955V18.4544H10.7545V14.5955C10.7545 14.4951 10.7977 14.4096 10.872 14.3535C10.9411 14.3013 11.0255 14.2827 11.1023 14.2827C11.179 14.2827 11.2634 14.3013 11.3325 14.3535C11.4068 14.4096 11.45 14.4951 11.45 14.5955V18.8022C11.45 18.9942 11.2944 19.1499 11.1023 19.1499H1.79248C1.6004 19.1499 1.44473 18.9942 1.44473 18.8022V14.5955C1.44473 14.4951 1.48793 14.4096 1.56222 14.3535C1.63134 14.3013 1.71574 14.2827 1.79248 14.2827Z"
        fill="#2B2E2D"
        stroke="#2B2E2D"
        strokeWidth="0.3"
      />
    </svg>
  ),
  viewBox: '0 0 13 20',
});

export const PulseCellDarkIcon = createIcon({
  displayName: 'PulseCellDarkIcon',
  path: (
    <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6966 6.21417H1.19775C1.00567 6.21417 0.85 6.36984 0.85 6.56192V13.8178C0.85 14.0099 1.00567 14.1656 1.19775 14.1656H11.6966C11.8887 14.1656 12.0444 14.0099 12.0444 13.8178V6.56192C12.0444 6.36984 11.8887 6.21417 11.6966 6.21417ZM11.3489 13.4701H1.54551V6.90968H11.3489V13.4701Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M6.37289 11.7463C7.55989 11.7463 8.52214 10.7841 8.52214 9.59707C8.52214 8.41007 7.55989 7.44781 6.37289 7.44781C5.18589 7.44781 4.22363 8.41007 4.22363 9.59707C4.22363 10.7841 5.18589 11.7463 6.37289 11.7463Z"
        fill="white"
      />
      <path d="M6.62859 8.40405H7.50859L7.13264 10.7829H6.25098L6.62859 8.40405Z" fill="#2B2E2D" />
      <path d="M5.55759 8.40419H6.43925L6.0633 10.783H5.18164L5.55759 8.40419Z" fill="#2B2E2D" />
      <path
        d="M3.64911 11.8447C3.29125 11.8447 3 12.1359 3 12.4938C3 12.8517 3.29117 13.1429 3.64911 13.1429C4.00704 13.1429 4.29822 12.8517 4.29822 12.4938C4.29814 12.1359 4.00697 11.8447 3.64911 11.8447ZM3.64911 12.7474C3.50926 12.7474 3.39551 12.6337 3.39551 12.4938C3.39551 12.354 3.50926 12.2402 3.64911 12.2402C3.78896 12.2402 3.90271 12.354 3.90271 12.4938C3.90263 12.6337 3.78888 12.7474 3.64911 12.7474Z"
        fill="white"
      />
      <path
        d="M5.51434 11.8447C5.15649 11.8447 4.86523 12.1359 4.86523 12.4938C4.86523 12.8517 5.15641 13.1429 5.51434 13.1429C5.87228 13.1429 6.16345 12.8517 6.16345 12.4938C6.16345 12.1359 5.87228 11.8447 5.51434 11.8447ZM5.51434 12.7474C5.37449 12.7474 5.26074 12.6337 5.26074 12.4938C5.26074 12.354 5.37449 12.2402 5.51434 12.2402C5.6542 12.2402 5.76794 12.354 5.76794 12.4938C5.76794 12.6337 5.6542 12.7474 5.51434 12.7474Z"
        fill="white"
      />
      <path
        d="M7.38055 11.8447C7.02262 11.8447 6.73145 12.1359 6.73145 12.4938C6.73145 12.8517 7.02262 13.1429 7.38055 13.1429C7.73841 13.1429 8.02966 12.8517 8.02966 12.4938C8.02966 12.1359 7.73841 11.8447 7.38055 11.8447ZM7.38055 12.7474C7.2407 12.7474 7.12695 12.6337 7.12695 12.4938C7.12695 12.354 7.2407 12.2402 7.38055 12.2402C7.52041 12.2402 7.63415 12.354 7.63415 12.4938C7.63415 12.6337 7.52041 12.7474 7.38055 12.7474Z"
        fill="white"
      />
      <path
        d="M9.24579 11.8447C8.88793 11.8447 8.59668 12.1359 8.59668 12.4938C8.59668 12.8517 8.88785 13.1429 9.24579 13.1429C9.60372 13.1429 9.8949 12.8517 9.8949 12.4938C9.8949 12.1359 9.60372 11.8447 9.24579 11.8447ZM9.24579 12.7474C9.10594 12.7474 8.99219 12.6337 8.99219 12.4938C8.99219 12.354 9.10594 12.2402 9.24579 12.2402C9.38564 12.2402 9.49939 12.354 9.49939 12.4938C9.49939 12.6337 9.38564 12.7474 9.24579 12.7474Z"
        fill="white"
      />
      <path
        d="M2.18338 6.15C2.26174 6.15 2.34612 6.12726 2.41291 6.0677C2.4823 6.00581 2.51677 5.91825 2.51677 5.82182V1.58299H10.4832V5.82182C10.4832 5.91825 10.5177 6.0058 10.5871 6.0677C10.6539 6.12726 10.7383 6.15 10.8166 6.15C10.895 6.15 10.9794 6.12726 11.0461 6.0677C11.1155 6.00581 11.15 5.91825 11.15 5.82182V1.2165C11.15 1.03837 11.0231 0.85 10.8166 0.85H2.18338C1.97686 0.85 1.85 1.03837 1.85 1.2165V5.82182C1.85 5.91825 1.88447 6.00581 1.95386 6.0677C2.02064 6.12726 2.10502 6.15 2.18338 6.15Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M1.79248 14.2827C1.86923 14.2827 1.95362 14.3013 2.02274 14.3535C2.09703 14.4096 2.14024 14.4951 2.14024 14.5955V18.4544H10.7545V14.5955C10.7545 14.4951 10.7977 14.4096 10.872 14.3535C10.9411 14.3013 11.0255 14.2827 11.1023 14.2827C11.179 14.2827 11.2634 14.3013 11.3325 14.3535C11.4068 14.4096 11.45 14.4951 11.45 14.5955V18.8022C11.45 18.9942 11.2944 19.1499 11.1023 19.1499H1.79248C1.6004 19.1499 1.44473 18.9942 1.44473 18.8022V14.5955C1.44473 14.4951 1.48793 14.4096 1.56222 14.3535C1.63134 14.3013 1.71574 14.2827 1.79248 14.2827Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
    </svg>
  ),
  viewBox: '0 0 13 20',
});

export const SolarCellIcon = createIcon({
  displayName: 'SolarIcon',
  path: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6839 3.74026C10.6839 4.31564 10.2193 4.77717 9.64703 4.77717H6.83476C6.25938 4.77717 5.79785 4.31256 5.79785 3.74026C5.79785 3.30027 6.07169 2.92181 6.45938 2.77104C6.43169 2.66643 6.41631 2.55566 6.41631 2.43874C6.41631 1.70029 7.01937 1.1003 7.75783 1.1003C8.49628 1.1003 9.09627 1.70029 9.09627 2.43874C9.09627 2.52797 9.09012 2.61412 9.07166 2.70028H9.64703C10.2193 2.70335 10.6839 3.16489 10.6839 3.74026Z"
        fill="currentColor"
      />
      <path d="M8.24121 9.63866H10.7766L10.5366 7.87561H8.24121V9.63866Z" fill="currentColor" />
      <path d="M4.80176 11.7094H7.62634V10.254H5.00176L4.80176 11.7094Z" fill="currentColor" />
      <path d="M8.24121 10.254V11.7094H11.0627L10.8627 10.254H8.24121Z" fill="currentColor" />
      <path d="M7.62632 7.87561H5.33096L5.08789 9.63866H7.62632V7.87561Z" fill="currentColor" />
      <path d="M8.24121 13.7833H11.3489L11.1489 12.3248H8.24121V13.7833Z" fill="currentColor" />
      <path
        d="M15.5521 14.3986H12.0537L12.2968 16.1617H15.3183C15.6814 16.1617 15.946 15.817 15.8475 15.4663L15.5521 14.3986Z"
        fill="currentColor"
      />
      <path d="M4.09678 12.3248H0.88144L0.481445 13.7833H3.89679L4.09678 12.3248Z" fill="currentColor" />
      <path d="M4.38304 10.254H1.45078L1.05078 11.7094H4.18305L4.38304 10.254Z" fill="currentColor" />
      <path d="M7.62536 14.3986H4.43155L4.18848 16.1617H7.62536V14.3986Z" fill="currentColor" />
      <path
        d="M4.46609 9.63866L4.70916 7.87561H2.52457C2.27535 7.87561 2.05996 8.04176 1.99535 8.27868L1.62305 9.63866H4.46609Z"
        fill="currentColor"
      />
      <path
        d="M3.8105 14.3986H0.312079L0.0197755 15.4663C-0.0756079 15.817 0.185927 16.1617 0.548999 16.1617H3.5705L3.8105 14.3986Z"
        fill="currentColor"
      />
      <path
        d="M11.3982 9.63866H14.2443L13.872 8.27868C13.8074 8.03868 13.5889 7.87561 13.3428 7.87561H11.1582L11.3982 9.63866Z"
        fill="currentColor"
      />
      <path d="M14.9819 12.3248H11.7666L11.9666 13.7833H15.3819L14.9819 12.3248Z" fill="currentColor" />
      <path d="M11.4319 14.3986H8.24121V16.1617H11.675L11.4319 14.3986Z" fill="currentColor" />
      <path d="M11.6844 11.7094H14.8136L14.4136 10.254H11.4844L11.6844 11.7094Z" fill="currentColor" />
      <path d="M7.62523 13.7833V12.3248H4.71758L4.51758 13.7833H7.62523Z" fill="currentColor" />
      <path d="M8.75761 16.7771H7.1084V18.1586H8.75761V16.7771Z" fill="currentColor" />
      <path
        d="M11.2111 19.3247V20.0016H4.6543V19.3247C4.6543 19.0201 4.90045 18.7739 5.20506 18.7739H10.6604C10.965 18.7739 11.2111 19.0201 11.2111 19.3247Z"
        fill="currentColor"
      />
      <path
        d="M17.9772 3.74332C17.9772 4.691 17.2049 5.4633 16.2542 5.4633C15.3065 5.4633 14.5342 4.691 14.5342 3.74332C14.5342 2.79256 15.3065 2.02026 16.2542 2.02026C17.2049 2.02026 17.9772 2.79256 17.9772 3.74332Z"
        fill="currentColor"
      />
      <path
        d="M15.1591 1.40193C15.0391 1.40193 14.9253 1.33116 14.876 1.21424L14.5468 0.429634C14.4822 0.272713 14.556 0.0911767 14.713 0.0265622C14.8699 -0.0380524 15.0483 0.0357928 15.116 0.192714L15.4453 0.977319C15.5099 1.13424 15.436 1.31578 15.2791 1.38039C15.2391 1.3927 15.1991 1.40193 15.1591 1.40193Z"
        fill="currentColor"
      />
      <path
        d="M13.6049 2.95572C13.5649 2.95572 13.5249 2.94648 13.4849 2.9311L12.7003 2.60187C12.5433 2.53726 12.4695 2.35572 12.5341 2.1988C12.5987 2.04188 12.7803 1.96804 12.9372 2.03265L13.7218 2.36188C13.8787 2.42649 13.9526 2.60803 13.8879 2.76495C13.8418 2.88495 13.7249 2.95572 13.6049 2.95572Z"
        fill="currentColor"
      />
      <path
        d="M12.8201 5.47249C12.7001 5.47249 12.5863 5.40172 12.537 5.2848C12.4724 5.12788 12.5463 4.94634 12.7032 4.88173L13.4878 4.5525C13.6447 4.48789 13.8232 4.56173 13.8909 4.71865C13.9555 4.87557 13.8816 5.05711 13.7247 5.12172L12.9401 5.45095C12.9001 5.46634 12.8601 5.47249 12.8201 5.47249Z"
        fill="currentColor"
      />
      <path
        d="M14.833 7.48177C14.793 7.48177 14.753 7.47254 14.713 7.45716C14.556 7.39254 14.4822 7.21101 14.5468 7.05409L14.876 6.26948C14.9407 6.11256 15.1222 6.03871 15.2791 6.10333C15.436 6.16794 15.5099 6.34948 15.4453 6.5064L15.116 7.29101C15.0668 7.411 14.953 7.48177 14.833 7.48177Z"
        fill="currentColor"
      />
      <path
        d="M17.6786 7.48169C17.5586 7.48169 17.4448 7.41092 17.3956 7.294L17.0663 6.50939C17.0017 6.35247 17.0756 6.17093 17.2325 6.10632C17.3894 6.04171 17.5679 6.11555 17.6356 6.27247L17.9648 7.05708C18.0294 7.214 17.9556 7.39553 17.7986 7.46015C17.7556 7.47553 17.7156 7.48169 17.6786 7.48169Z"
        fill="currentColor"
      />
      <path
        d="M19.6879 5.47258C19.6479 5.47258 19.6079 5.46335 19.5679 5.44796L18.7833 5.11873C18.6264 5.05412 18.5525 4.87258 18.6171 4.71566C18.6817 4.55874 18.8633 4.4849 19.0202 4.54951L19.8048 4.87874C19.9617 4.94335 20.0356 5.12489 19.971 5.28181C19.9217 5.40181 19.8079 5.47258 19.6879 5.47258Z"
        fill="currentColor"
      />
      <path
        d="M18.9031 2.95572C18.7831 2.95572 18.6693 2.88495 18.6201 2.76495C18.5554 2.60803 18.6293 2.42649 18.7862 2.36188L19.5739 2.03265C19.7308 1.96804 19.9093 2.04188 19.977 2.1988C20.0416 2.35572 19.9677 2.53726 19.8108 2.60187L19.0231 2.9311C18.9831 2.94648 18.9431 2.95572 18.9031 2.95572Z"
        fill="currentColor"
      />
      <path
        d="M17.3496 1.40182C17.3096 1.40182 17.2696 1.39259 17.2296 1.3772C17.0726 1.31259 16.9988 1.13105 17.0634 0.97413L17.3926 0.189525C17.4573 0.0326037 17.6388 -0.0412414 17.7957 0.0233731C17.9526 0.0879876 18.0265 0.269524 17.9619 0.426445L17.6326 1.21105C17.5834 1.33105 17.4696 1.40182 17.3496 1.40182Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 21',
});

export const BatteryCellIcon = createIcon({
  displayName: 'BatteryCellIcon',
  path: (
    <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.09588 18.6667L2.57085 18.6667C2.24278 18.6662 1.92827 18.5357 1.69628 18.3037C1.4643 18.0717 1.33378 17.7572 1.33334 17.4292L1.33334 11.7025L-4.07137e-07 10.6858L-1.12375e-07 17.4292C0.000771888 18.1107 0.271876 18.7642 0.753837 19.2462C1.2358 19.7281 1.88925 19.9992 2.57085 20L8.09588 20C8.77747 19.9992 9.43093 19.7281 9.91289 19.2462C10.3948 18.7642 10.666 18.1107 10.6667 17.4292L10.6667 13.3937C10.5651 13.4067 10.4621 13.4031 10.3617 13.3829L10.3305 13.3766L10.3001 13.3679L9.33338 13.097L9.33338 17.4292C9.33294 17.7572 9.20242 18.0717 8.97044 18.3037C8.73846 18.5357 8.42395 18.6662 8.09588 18.6667Z"
        fill="currentColor"
      />
      <path
        d="M-2.98186e-07 4.57083L-1.18531e-07 8.68085C0.0999613 8.6686 0.201238 8.6724 0.300001 8.6921L0.330835 8.69835L0.361252 8.7071L1.33334 8.9796L1.33334 4.57083C1.33378 4.24276 1.4643 3.92825 1.69628 3.69627C1.92827 3.46429 2.24277 3.33376 2.57085 3.33332L8.09588 3.33332C8.42395 3.33376 8.73846 3.46429 8.97044 3.69627C9.20242 3.92825 9.33294 4.24276 9.33338 4.57083L9.33338 10.375L10.6667 11.3925L10.6667 4.57083C10.666 3.88924 10.3948 3.23578 9.91289 2.75382C9.43093 2.27186 8.77747 2.00075 8.09588 1.99998L2.57085 1.99998C1.88925 2.00076 1.2358 2.27186 0.753836 2.75382C0.271876 3.23578 0.000771643 3.88924 -2.98186e-07 4.57083Z"
        fill="currentColor"
      />
      <path
        d="M6.92271 13.8897C6.92274 14.0745 6.87232 14.2559 6.77686 14.4142C6.6814 14.5725 6.54454 14.7018 6.38104 14.788C6.2133 14.8772 6.02436 14.9189 5.83466 14.9084C5.64496 14.898 5.46172 14.8359 5.30478 14.7288L5.28561 14.7159L5.26728 14.7022L2.29102 12.4326L2.29102 16.9297C2.29102 17.1507 2.37881 17.3627 2.53509 17.5189C2.69138 17.6752 2.90334 17.763 3.12435 17.763L7.54104 17.763C7.76206 17.763 7.97402 17.6752 8.1303 17.5189C8.28658 17.3627 8.37438 17.1507 8.37438 16.9297L8.37438 12.8288L6.92187 12.4213L6.92271 13.8897Z"
        fill="currentColor"
      />
      <path
        d="M6.36973 9.16356L4.89097 8.03564C4.86684 8.01975 4.83978 8.00884 4.81138 8.00356C4.8023 8.00184 4.79311 8.00072 4.78388 8.00022C4.7659 7.99901 4.74783 8.00013 4.73013 8.00356C4.70429 8.00842 4.67956 8.01802 4.65722 8.03189C4.64267 8.04097 4.62937 8.05189 4.61763 8.06439C4.61178 8.07058 4.60648 8.07727 4.6018 8.08439C4.5918 8.09852 4.58407 8.11413 4.57888 8.13064C4.57329 8.14829 4.57048 8.16671 4.57055 8.18523L4.57055 10.7527L2.77012 10.2477L2.29095 10.1132L1.36761 9.8544L1.29095 9.83315L0.134275 9.50856C0.126703 9.50727 0.11904 9.50657 0.111358 9.50648C0.108858 9.50648 0.106775 9.50648 0.104691 9.50648C0.102608 9.50648 0.0938579 9.50648 0.0888578 9.50856C0.0838578 9.51065 0.0851078 9.50856 0.0830245 9.50856C0.0765343 9.51023 0.0702469 9.51261 0.0642745 9.51565C0.0586384 9.51892 0.0532112 9.52254 0.0480245 9.52648L0.0438582 9.53023C0.0404505 9.5335 0.0372494 9.53698 0.0342743 9.54065L0.0309409 9.54482C0.0272165 9.54998 0.0238746 9.55541 0.0209412 9.56107C0.0183839 9.56653 0.016428 9.57226 0.0151079 9.57815L0.0151079 9.58357L0.0151079 9.59732L0.0151079 9.60273C0.014495 9.60897 0.014495 9.61525 0.0151079 9.62148C0.016497 9.62754 0.0185946 9.63341 0.0213577 9.63898L0.0242747 9.6444L0.0330244 9.6569L0.0371913 9.66148C0.0422971 9.66712 0.0480287 9.67215 0.0542749 9.67648L1.03886 10.4265L1.75637 10.974L2.29095 11.3844L5.77222 14.039C5.78283 14.046 5.79397 14.0521 5.80556 14.0573C5.82006 14.064 5.8353 14.0689 5.85097 14.0719C5.86865 14.0755 5.88674 14.0766 5.90472 14.0753C5.93509 14.0739 5.96476 14.0656 5.99152 14.0512C6.01828 14.0368 6.04145 14.0165 6.05931 13.9919C6.0641 13.9847 6.06842 13.9772 6.07222 13.9694C6.0841 13.9449 6.09022 13.9179 6.09014 13.8907L6.09014 11.3232L10.5243 12.5657C10.5321 12.5663 10.5399 12.5663 10.5477 12.5657C10.5477 12.5657 10.5518 12.5657 10.5539 12.5657C10.5593 12.5653 10.5645 12.5644 10.5697 12.5632C10.5717 12.5634 10.5736 12.5634 10.5756 12.5632C10.5821 12.5615 10.5884 12.5591 10.5943 12.5561C10.5998 12.5528 10.6051 12.5492 10.6102 12.5452L10.6143 12.5415L10.6243 12.5311C10.6252 12.5295 10.6263 12.5281 10.6277 12.5269C10.6314 12.5218 10.6346 12.5164 10.6372 12.5107C10.6396 12.5051 10.6416 12.4994 10.6431 12.4936L10.6431 12.4882C10.6435 12.4836 10.6435 12.479 10.6431 12.4744L10.6431 12.469C10.6429 12.4627 10.642 12.4564 10.6406 12.4502C10.639 12.4443 10.6367 12.4386 10.6339 12.4332L10.631 12.4277L10.6222 12.4152L10.6185 12.4107C10.6134 12.405 10.6077 12.4 10.6014 12.3957L9.33266 11.424L8.37432 10.6936L6.36973 9.16356Z"
        fill="currentColor"
      />
      <path
        d="M3.11035 0.666673C3.11035 0.843485 3.18059 1.01306 3.30561 1.13808C3.43064 1.26311 3.60021 1.33334 3.77702 1.33334L6.88787 1.33334C7.06468 1.33334 7.23425 1.26311 7.35928 1.13808C7.4843 1.01306 7.55454 0.843485 7.55454 0.666673C7.55454 0.489861 7.4843 0.32029 7.35928 0.195265C7.23425 0.0702406 7.06468 2.80738e-06 6.88787 2.81511e-06L3.77702 2.95109e-06C3.60021 2.95882e-06 3.43064 0.0702407 3.30561 0.195266C3.18059 0.320291 3.11035 0.489861 3.11035 0.666673Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 11 20',
});

export const CalendarIcon = createIcon({
  displayName: 'CalendarIcon',
  path: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_768_100844)">
        <path
          d="M11.7638 1.79861H11.0834V0.875H9.72221V1.79861H4.27778V0.875H2.91666V1.79861H2.23611C1.48069 1.79861 0.881806 2.41112 0.881806 3.15972L0.875 11.8125C0.875 12.5611 1.48069 13.125 2.23611 13.125H11.7638C12.5125 13.125 13.125 12.5611 13.125 11.8125V3.15972C13.125 2.41112 12.5125 1.79861 11.7638 1.79861ZM11.7638 11.8125H2.23611V4.32638H11.7638V11.8125Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_768_100844">
          <rect width="12.25" height="12.25" fill="white" transform="translate(0.875 0.875)" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 14 14',
});

export const PencilIcon = createIcon({
  path: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3327 2.83331L14.166 5.66665L6.37435 13.4583H3.54102V10.625L11.3327 2.83331Z"
        stroke="#9BA0A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 17 17',
});

export const TiltFlatGrayIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.91992 23.04V5.28003H11.9999H22.0799V23.04H1.91992Z" fill="#F1F1F2" />
      <path
        d="M11.9981 5.68122H21.487V22.8185H2.51286V5.68122H11.9981ZM11.7627 5.28003H1.91992V23.52H22.0799V5.28003H11.7627Z"
        fill="#6F6F6F"
      />
      <path d="M2.3999 20.4H21.5999V22.8H2.3999V20.4Z" fill="#9BA0A1" />
      <path d="M11.9981 4.32001H0.959961V6.72001H11.9981H23.04V4.32001H11.9981Z" fill="#6F6F6F" />
      <path d="M8.69995 12.9H15.2999V23.1H8.69995V12.9Z" fill="#EAEBEA" />
      <path d="M14.9999 13.2V22.8H8.9999V13.2H14.9999ZM15.5999 12.6H8.3999V23.4H15.5999V12.6Z" fill="#9BA0A1" />
      <path
        d="M13.8 18C13.4681 18 13.2 18.2681 13.2 18.6C13.2 18.9319 13.4681 19.2 13.8 19.2C14.1318 19.2 14.4 18.9319 14.4 18.6C14.4 18.2681 14.1318 18 13.8 18Z"
        fill="#9BA0A1"
      />
      <path d="M11.9982 4.79999H1.43994V6.23999H11.9982H22.5599V4.79999H11.9982Z" fill="#9BA0A1" />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const TiltPitchedGrayIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.09998 23.1V7.97249L11.9981 2.14874L21.9 7.97249V23.1H2.09998Z" fill="#F1F1F2" />
      <path
        d="M11.9981 2.49561L21.6 8.14311V22.8H2.39999V8.14311L11.9981 2.49561ZM11.9981 1.79999L1.79999 7.79999V23.4H22.2V7.79999L11.9981 1.79999Z"
        fill="#6F6F6F"
      />
      <path d="M2.39996 20.4H21.6V22.8H2.39996V20.4Z" fill="#9BA0A1" />
      <path
        d="M11.9981 2.7862L0.899963 9.5737V7.73808L11.9981 0.952454L23.1 7.73808V9.5737L11.9981 2.7862Z"
        fill="#9BA0A1"
      />
      <path
        d="M11.9981 1.3031L22.8 7.90498V9.03748L12.3112 2.62685L11.9981 2.4356L11.685 2.62685L1.19998 9.03748V7.90498L11.9981 1.3031ZM11.9981 0.599976L0.599976 7.56935V10.1081L11.9981 3.13873L23.4 10.1081V7.56935L11.9981 0.599976Z"
        fill="#6F6F6F"
      />
      <path d="M8.69995 12.9H15.2999V23.1H8.69995V12.9Z" fill="#EAEBEA" />
      <path d="M15 13.2V22.8H8.99996V13.2H15ZM15.6 12.6H8.39996V23.4H15.6V12.6Z" fill="#9BA0A1" />
      <path
        d="M13.8 18C13.4681 18 13.2 18.2681 13.2 18.6C13.2 18.9319 13.4681 19.2 13.8 19.2C14.1318 19.2 14.4 18.9319 14.4 18.6C14.4 18.2681 14.1318 18 13.8 18Z"
        fill="#9BA0A1"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const TiltFlatColoredIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.91992 23.04V5.28003H11.9999H22.0799V23.04H1.91992Z" fill="#DBF2FF" />
      <path
        d="M11.9981 5.68122H21.487V22.8185H2.51286V5.68122H11.9981ZM11.7627 5.28003H1.91992V23.52H22.0799V5.28003H11.7627Z"
        fill="#7496C4"
      />
      <path d="M2.3999 20.4H21.5999V22.8H2.3999V20.4Z" fill="#B5DDF5" />
      <path d="M11.9981 4.32001H0.959961V6.72001H11.9981H23.04V4.32001H11.9981Z" fill="#C74343" />
      <path d="M8.69995 12.9H15.2999V23.1H8.69995V12.9Z" fill="#FFC49C" />
      <path d="M14.9999 13.2V22.8H8.9999V13.2H14.9999ZM15.5999 12.6H8.3999V23.4H15.5999V12.6Z" fill="#A16A4A" />
      <path
        d="M13.8 18C13.4681 18 13.2 18.2681 13.2 18.6C13.2 18.9319 13.4681 19.2 13.8 19.2C14.1318 19.2 14.4 18.9319 14.4 18.6C14.4 18.2681 14.1318 18 13.8 18Z"
        fill="#A16A4A"
      />
      <path d="M11.9982 4.79999H1.43994V6.23999H11.9982H22.5599V4.79999H11.9982Z" fill="#F78F8F" />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const TiltPitchedColoredIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.1001 23.1V7.97249L11.9982 2.14874L21.9001 7.97249V23.1H2.1001Z" fill="#F1F1F2" />
      <path
        d="M11.9982 2.49561L21.6 8.14311V22.8H2.40005V8.14311L11.9982 2.49561ZM11.9982 1.79999L1.80005 7.79999V23.4H22.2V7.79999L11.9982 1.79999Z"
        fill="#7496C4"
      />
      <path d="M2.40015 20.4H21.6001V22.8H2.40015V20.4Z" fill="#B5DDF5" />
      <path
        d="M11.9983 2.7862L0.900146 9.5737V7.73808L11.9983 0.952454L23.1001 7.73808V9.5737L11.9983 2.7862Z"
        fill="#F78F8F"
      />
      <path
        d="M11.9982 1.3031L22.8001 7.90498V9.03748L12.3113 2.62685L11.9982 2.4356L11.6851 2.62685L1.2001 9.03748V7.90498L11.9982 1.3031ZM11.9982 0.599976L0.600098 7.56935V10.1081L11.9982 3.13873L23.4001 10.1081V7.56935L11.9982 0.599976Z"
        fill="#C74343"
      />
      <path d="M8.7002 12.9H15.3002V23.1H8.7002V12.9Z" fill="#FFC49C" />
      <path d="M15.0001 13.2V22.8H9.00015V13.2H15.0001ZM15.6001 12.6H8.40015V23.4H15.6001V12.6Z" fill="#A16A4A" />
      <path
        d="M13.8002 18C13.4683 18 13.2002 18.2681 13.2002 18.6C13.2002 18.9319 13.4683 19.2 13.8002 19.2C14.1321 19.2 14.4002 18.9319 14.4002 18.6C14.4002 18.2681 14.1321 18 13.8002 18Z"
        fill="#A16A4A"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const CompassIcon = createIcon({
  path: (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 41.6875C32.7178 41.6875 41.4062 32.999 41.4062 22.2812C41.4062 11.5635 32.7178 2.875 22 2.875C11.2822 2.875 2.59375 11.5635 2.59375 22.2812C2.59375 32.999 11.2822 41.6875 22 41.6875Z"
        fill="#E3E6E8"
      />
      <path
        d="M14.4614 23.4232L21.3901 34.5194C21.4547 34.623 21.5446 34.7084 21.6513 34.7676C21.758 34.8268 21.878 34.8579 22 34.8579C22.122 34.8579 22.242 34.8268 22.3487 34.7676C22.4554 34.7084 22.5453 34.623 22.6099 34.5194L29.5386 23.4232C29.7525 23.0807 29.8659 22.685 29.8659 22.2812C29.8659 21.8774 29.7525 21.4817 29.5386 21.1392L22.6099 10.0429C22.5453 9.93939 22.4554 9.854 22.3487 9.79479C22.242 9.73558 22.122 9.70451 22 9.70451C21.878 9.70451 21.758 9.73558 21.6513 9.79479C21.5446 9.854 21.4547 9.93939 21.3901 10.0429L14.4614 21.1392C14.2475 21.4817 14.1341 21.8774 14.1341 22.2812C14.1341 22.685 14.2475 23.0807 14.4614 23.4232Z"
        fill="#30B2E5"
      />
      <path
        d="M22.0144 8.625H21.9856C21.7987 8.62509 21.6136 8.58835 21.4409 8.51686C21.2682 8.44538 21.1113 8.34055 20.9791 8.20839C20.8469 8.07622 20.7421 7.9193 20.6706 7.74659C20.5992 7.57389 20.5624 7.38879 20.5625 7.20187V4.3125H23.4375V7.20187C23.4376 7.38879 23.4008 7.57389 23.3294 7.74659C23.2579 7.9193 23.1531 8.07622 23.0209 8.20839C22.8887 8.34055 22.7318 8.44538 22.5591 8.51686C22.3864 8.58835 22.2013 8.62509 22.0144 8.625Z"
        fill="#CACBCC"
      />
      <path
        d="M35.6563 22.2956V22.2669C35.6562 22.08 35.6929 21.8949 35.7644 21.7222C35.8359 21.5495 35.9407 21.3925 36.0729 21.2604C36.205 21.1282 36.362 21.0234 36.5347 20.9519C36.7074 20.8804 36.8925 20.8437 37.0794 20.8438H39.9688V23.7188H37.0794C36.8925 23.7188 36.7074 23.6821 36.5347 23.6106C36.362 23.5391 36.205 23.4343 36.0729 23.3021C35.9407 23.17 35.8359 23.013 35.7644 22.8403C35.6929 22.6676 35.6562 22.4825 35.6563 22.2956Z"
        fill="#CACBCC"
      />
      <path
        d="M21.9856 35.9375H22.0144C22.2013 35.9374 22.3864 35.9742 22.5591 36.0456C22.7318 36.1171 22.8887 36.2219 23.0209 36.3541C23.1531 36.4863 23.2579 36.6432 23.3294 36.8159C23.4008 36.9886 23.4376 37.1737 23.4375 37.3606V40.25H20.5625V37.3606C20.5624 37.1737 20.5992 36.9886 20.6706 36.8159C20.7421 36.6432 20.8469 36.4863 20.9791 36.3541C21.1113 36.2219 21.2682 36.1171 21.4409 36.0456C21.6136 35.9742 21.7987 35.9374 21.9856 35.9375Z"
        fill="#CACBCC"
      />
      <path
        d="M8.34375 22.2669V22.2956C8.34384 22.4825 8.3071 22.6676 8.23561 22.8403C8.16413 23.013 8.0593 23.17 7.92714 23.3021C7.79497 23.4343 7.63805 23.5391 7.46534 23.6106C7.29264 23.6821 7.10754 23.7188 6.92062 23.7188H4.03125V20.8438H6.92062C7.10754 20.8437 7.29264 20.8804 7.46534 20.9519C7.63805 21.0234 7.79497 21.1282 7.92714 21.2604C8.0593 21.3925 8.16413 21.5495 8.23561 21.7222C8.3071 21.8949 8.34384 22.08 8.34375 22.2669Z"
        fill="#CACBCC"
      />
      <path
        d="M22 43.8438C17.7353 43.8438 13.5665 42.5791 10.0205 40.2098C6.47459 37.8405 3.71087 34.4729 2.07886 30.5329C0.446843 26.5928 0.0198332 22.2573 0.851827 18.0746C1.68382 13.8919 3.73745 10.0498 6.75302 7.03427C9.76859 4.0187 13.6107 1.96507 17.7934 1.13308C21.9761 0.301083 26.3116 0.728093 30.2516 2.36011C34.1917 3.99212 37.5593 6.75584 39.9286 10.3018C42.2979 13.8477 43.5625 18.0166 43.5625 22.2813C43.556 27.998 41.2822 33.4788 37.2399 37.5211C33.1975 41.5635 27.7168 43.8373 22 43.8438ZM22 5.03126C18.5883 5.03126 15.2532 6.04295 12.4164 7.93841C9.57968 9.83386 7.3687 12.5279 6.06309 15.68C4.75748 18.832 4.41587 22.3004 5.08146 25.6466C5.74706 28.9927 7.38996 32.0664 9.80242 34.4789C12.2149 36.8913 15.2885 38.5342 18.6347 39.1998C21.9809 39.8654 25.4493 39.5238 28.6013 38.2182C31.7533 36.9126 34.4474 34.7016 36.3429 31.8648C38.2383 29.0281 39.25 25.693 39.25 22.2813C39.2449 17.7079 37.4258 13.3232 34.1919 10.0893C30.958 6.85545 26.5734 5.0364 22 5.03126Z"
        fill="#AEBCC5"
      />
      <path
        d="M24.0329 24.3142C25.1556 23.1914 25.1556 21.3711 24.0329 20.2483C22.9101 19.1256 21.0898 19.1256 19.967 20.2483C18.8443 21.3711 18.8443 23.1914 19.967 24.3142C21.0898 25.4369 22.9101 25.4369 24.0329 24.3142Z"
        fill="white"
      />
    </svg>
  ),
  viewBox: '0 0 44 44',
});

export const InfoIcon = createIcon({
  path: (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.0013 67.3334C15.5913 67.3334 0.667969 52.4101 0.667969 34.0001C0.667969 15.5901 15.5913 0.666748 34.0013 0.666748C52.4113 0.666748 67.3346 15.5901 67.3346 34.0001C67.3346 52.4101 52.4113 67.3334 34.0013 67.3334ZM30.668 30.6667V50.6668H37.3346V30.6667H30.668ZM30.668 17.3334V24.0001H37.3346V17.3334H30.668Z"
        fill="#007AFF"
      />
    </svg>
  ),
  viewBox: '0 0 68 68',
});

export const BinIcon = createIcon({
  path: (
    <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="33.5" cy="33.5" r="33.5" fill="#E53E3E" />
      <path
        d="M39.125 51.7812H27.875C26.0102 51.7812 24.2218 51.0405 22.9032 49.7218C21.5845 48.4032 20.8438 46.6148 20.8438 44.75V27.875C20.8438 27.502 20.9919 27.1444 21.2556 26.8806C21.5194 26.6169 21.877 26.4688 22.25 26.4688C22.623 26.4688 22.9806 26.6169 23.2444 26.8806C23.5081 27.1444 23.6562 27.502 23.6562 27.875V44.75C23.6562 45.8689 24.1007 46.9419 24.8919 47.7331C25.6831 48.5243 26.7561 48.9688 27.875 48.9688H39.125C40.2439 48.9688 41.3169 48.5243 42.1081 47.7331C42.8993 46.9419 43.3438 45.8689 43.3438 44.75V27.875C43.3438 27.502 43.4919 27.1444 43.7556 26.8806C44.0194 26.6169 44.377 26.4688 44.75 26.4688C45.123 26.4688 45.4806 26.6169 45.7444 26.8806C46.0081 27.1444 46.1562 27.502 46.1562 27.875V44.75C46.1562 46.6148 45.4155 48.4032 44.0968 49.7218C42.7782 51.0405 40.9898 51.7812 39.125 51.7812Z"
        fill="white"
      />
      <path
        d="M47.5625 23.6562H19.4375C19.0645 23.6562 18.7069 23.5081 18.4431 23.2444C18.1794 22.9806 18.0312 22.623 18.0312 22.25C18.0312 21.877 18.1794 21.5194 18.4431 21.2556C18.7069 20.9919 19.0645 20.8438 19.4375 20.8438H47.5625C47.9355 20.8438 48.2931 20.9919 48.5569 21.2556C48.8206 21.5194 48.9688 21.877 48.9688 22.25C48.9688 22.623 48.8206 22.9806 48.5569 23.2444C48.2931 23.5081 47.9355 23.6562 47.5625 23.6562Z"
        fill="white"
      />
      <path
        d="M39.125 23.6562H27.875C27.502 23.6562 27.1444 23.5081 26.8806 23.2444C26.6169 22.9806 26.4688 22.623 26.4688 22.25V19.4375C26.4688 18.3186 26.9132 17.2456 27.7044 16.4544C28.4956 15.6632 29.5686 15.2188 30.6875 15.2188H36.3125C37.4314 15.2188 38.5044 15.6632 39.2956 16.4544C40.0868 17.2456 40.5312 18.3186 40.5312 19.4375V22.25C40.5312 22.623 40.3831 22.9806 40.1194 23.2444C39.8556 23.5081 39.498 23.6562 39.125 23.6562ZM29.2812 20.8438H37.7188V19.4375C37.7188 19.0645 37.5706 18.7069 37.3069 18.4431C37.0431 18.1794 36.6855 18.0312 36.3125 18.0312H30.6875C30.3145 18.0312 29.9569 18.1794 29.6931 18.4431C29.4294 18.7069 29.2812 19.0645 29.2812 19.4375V20.8438Z"
        fill="white"
      />
      <path
        d="M30.6875 43.3438C30.3145 43.3438 29.9569 43.1956 29.6931 42.9319C29.4294 42.6681 29.2812 42.3105 29.2812 41.9375V32.0938C29.2812 31.7208 29.4294 31.3631 29.6931 31.0994C29.9569 30.8357 30.3145 30.6875 30.6875 30.6875C31.0605 30.6875 31.4181 30.8357 31.6819 31.0994C31.9456 31.3631 32.0938 31.7208 32.0938 32.0938V41.9375C32.0938 42.3105 31.9456 42.6681 31.6819 42.9319C31.4181 43.1956 31.0605 43.3438 30.6875 43.3438Z"
        fill="white"
      />
      <path
        d="M36.3125 43.3438C35.9395 43.3438 35.5819 43.1956 35.3181 42.9319C35.0544 42.6681 34.9062 42.3105 34.9062 41.9375V32.0938C34.9062 31.7208 35.0544 31.3631 35.3181 31.0994C35.5819 30.8357 35.9395 30.6875 36.3125 30.6875C36.6855 30.6875 37.0431 30.8357 37.3069 31.0994C37.5706 31.3631 37.7188 31.7208 37.7188 32.0938V41.9375C37.7188 42.3105 37.5706 42.6681 37.3069 42.9319C37.0431 43.1956 36.6855 43.3438 36.3125 43.3438Z"
        fill="white"
      />
    </svg>
  ),
  viewBox: '0 0 67 67',
});

export const HouseNormalIcon = createIcon({
  path: (
    <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.0301 13.0746L9.66404 8.72902C9.00661 8.19707 8.0528 8.19707 7.39537 8.72902L2.03004 13.0739C1.8417 13.2262 1.73438 13.4515 1.73438 13.6923V21.8686C1.73438 22.3078 2.0933 22.669 2.53395 22.669H6.13169C6.57234 22.669 6.93127 22.3078 6.93127 21.8686V16.6935H10.1289V21.8686C10.1289 22.3078 10.4878 22.669 10.9284 22.669H14.5262C14.9668 22.669 15.3258 22.3078 15.3258 21.8686V13.6923C15.325 13.4515 15.2177 13.2262 15.0301 13.0746ZM14.5255 21.8729H10.9277V16.69C10.9277 16.2508 10.5688 15.8974 10.1281 15.8974H6.93055C6.4899 15.8974 6.13098 16.2508 6.13098 16.69V21.8729H2.53395V13.6923L7.9 9.3474C8.2646 9.05132 8.79552 9.05202 9.16013 9.3474L14.5262 13.6923V21.8729H14.5255Z"
        fill="currentColor"
      />
      <path
        d="M17.056 1.68726C13.0103 1.68726 9.71875 4.96769 9.71875 8.99975C9.71875 13.0318 13.0103 16.3123 17.056 16.3123C21.1018 16.3123 24.3933 13.0318 24.3933 8.99975C24.3933 4.96769 21.1018 1.68726 17.056 1.68726ZM15.7156 12.6694L12.8724 9.52042L13.7116 8.76772L15.687 10.9551L20.3719 5.39483L21.2376 6.11694L15.7156 12.6694Z"
        fill="#3DCD58"
      />
    </svg>
  ),
  viewBox: '0 0 27 24',
});

export const HouseFaultIcon = createIcon({
  path: (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9774 14.0746L9.62944 9.72902C8.97423 9.19707 8.02365 9.19707 7.36844 9.72902L2.02123 14.0739C1.83352 14.2262 1.72656 14.4515 1.72656 14.6923V22.8686C1.72656 23.3078 2.08427 23.669 2.52344 23.669H6.10902C6.54819 23.669 6.9059 23.3078 6.9059 22.8686V17.6935H10.0927V22.8686C10.0927 23.3078 10.4504 23.669 10.8896 23.669H14.4751C14.9143 23.669 15.272 23.3078 15.272 22.8686V14.6923C15.2713 14.4515 15.1644 14.2262 14.9774 14.0746ZM14.4744 22.8729H10.8889V17.69C10.8889 17.2508 10.5311 16.8974 10.092 16.8974H6.90519C6.46602 16.8974 6.10831 17.2508 6.10831 17.69V22.8729H2.52344V14.6923L7.87135 10.3474C8.23473 10.0513 8.76385 10.052 9.12723 10.3474L14.4751 14.6923V22.8729H14.4744Z"
        fill="currentColor"
      />
      <g clipPath="url(#clip0_591_164849)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.36508 13.5L15.7176 2.895C15.8513 2.67458 16.0395 2.49234 16.2642 2.36586C16.4888 2.23939 16.7423 2.17294 17.0001 2.17294C17.2579 2.17294 17.5113 2.23939 17.736 2.36586C17.9606 2.49234 18.1489 2.67458 18.2826 2.895L24.6351 13.5C24.766 13.7268 24.8354 13.984 24.8361 14.2459C24.8368 14.5078 24.769 14.7653 24.6393 14.9929C24.5096 15.2204 24.3225 15.4101 24.0968 15.5429C23.8711 15.6757 23.6145 15.7471 23.3526 15.75H10.6476C10.3857 15.7471 10.1291 15.6757 9.90336 15.5429C9.67762 15.4101 9.4906 15.2204 9.3609 14.9929C9.23119 14.7653 9.16334 14.5078 9.16407 14.2459C9.1648 13.984 9.2341 13.7268 9.36508 13.5ZM16.2969 13.684H17.7032V12.2777H16.2969V13.684ZM16.4376 11.4371H17.5626L17.7735 5.81213H16.2266L16.4376 11.4371Z"
          fill="#E53E3E"
        />
      </g>
      <defs>
        <clipPath id="clip0_591_164849">
          <rect width="18" height="18" fill="white" transform="translate(8)" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 26 25',
});

export const HouseOfflineIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9774 13.0746L9.62944 8.72902C8.97423 8.19707 8.02365 8.19707 7.36844 8.72902L2.02123 13.0739C1.83352 13.2262 1.72656 13.4515 1.72656 13.6923V21.8686C1.72656 22.3078 2.08427 22.669 2.52344 22.669H6.10902C6.54819 22.669 6.9059 22.3078 6.9059 21.8686V16.6935H10.0927V21.8686C10.0927 22.3078 10.4504 22.669 10.8896 22.669H14.4751C14.9143 22.669 15.272 22.3078 15.272 21.8686V13.6923C15.2713 13.4515 15.1644 13.2262 14.9774 13.0746ZM14.4744 21.8729H10.8889V16.69C10.8889 16.2508 10.5311 15.8974 10.092 15.8974H6.90519C6.46602 15.8974 6.10831 16.2508 6.10831 16.69V21.8729H2.52344V13.6923L7.87135 9.3474C8.23473 9.05132 8.76385 9.05202 9.12723 9.3474L14.4751 13.6923V21.8729H14.4744Z"
        fill="currentColor"
      />
      <circle cx="16" cy="8" r="8" fill="white" />
      <path
        d="M18.5844 9.7503C18.0088 9.23868 17.2654 8.95607 16.4953 8.95607C15.7252 8.95607 14.9819 9.23868 14.4062 9.7503"
        stroke="#9BA0A1"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.2556 8.08215C19.2362 7.1289 17.8926 6.5986 16.497 6.5986C15.1013 6.5986 13.7577 7.1289 12.7383 8.08215"
        stroke="#9BA0A1"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21.7386 6.23735C20.2957 4.95021 18.4298 4.23887 16.4962 4.23887C14.5627 4.23887 12.6968 4.95021 11.2539 6.23735"
        stroke="#9BA0A1"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.7112 11.5005L16.4898 12.8404L15.2773 11.5005C15.4226 11.3173 15.6074 11.1692 15.8179 11.0674C16.0284 10.9657 16.2592 10.9128 16.493 10.9128C16.7269 10.9128 16.9577 10.9657 17.1682 11.0674C17.3787 11.1692 17.5635 11.3173 17.7087 11.5005H17.7112Z"
        fill="#9BA0A1"
      />
      <path d="M11.2383 12.9583L21.7383 2.75" stroke="currentColor" />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const HouseOfflineDarkIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9774 13.0746L9.62944 8.72902C8.97423 8.19707 8.02365 8.19707 7.36844 8.72902L2.02123 13.0739C1.83352 13.2262 1.72656 13.4515 1.72656 13.6923V21.8686C1.72656 22.3078 2.08427 22.669 2.52344 22.669H6.10902C6.54819 22.669 6.9059 22.3078 6.9059 21.8686V16.6935H10.0927V21.8686C10.0927 22.3078 10.4504 22.669 10.8896 22.669H14.4751C14.9143 22.669 15.272 22.3078 15.272 21.8686V13.6923C15.2713 13.4515 15.1644 13.2262 14.9774 13.0746ZM14.4744 21.8729H10.8889V16.69C10.8889 16.2508 10.5311 15.8974 10.092 15.8974H6.90519C6.46602 15.8974 6.10831 16.2508 6.10831 16.69V21.8729H2.52344V13.6923L7.87135 9.3474C8.23473 9.05132 8.76385 9.05202 9.12723 9.3474L14.4751 13.6923V21.8729H14.4744Z"
        fill="currentColor"
      />
      <circle cx="16" cy="8" r="8" fill="#171923" />
      <path
        d="M18.5844 9.7503C18.0088 9.23868 17.2654 8.95607 16.4953 8.95607C15.7252 8.95607 14.9819 9.23868 14.4062 9.7503"
        stroke="#9BA0A1"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.2556 8.08215C19.2362 7.1289 17.8926 6.5986 16.497 6.5986C15.1013 6.5986 13.7577 7.1289 12.7383 8.08215"
        stroke="#9BA0A1"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21.7386 6.23735C20.2957 4.95021 18.4298 4.23887 16.4962 4.23887C14.5627 4.23887 12.6968 4.95021 11.2539 6.23735"
        stroke="#9BA0A1"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.7112 11.5005L16.4898 12.8404L15.2773 11.5005C15.4226 11.3173 15.6074 11.1692 15.8179 11.0674C16.0284 10.9657 16.2592 10.9128 16.493 10.9128C16.7269 10.9128 16.9577 10.9657 17.1682 11.0674C17.3787 11.1692 17.5635 11.3173 17.7087 11.5005H17.7112Z"
        fill="#9BA0A1"
      />
      <path d="M11.2383 12.9583L21.7383 2.75" stroke="currentColor" />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const ZeroProductionIcon = createIcon({
  path: (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="18.5403" height="18.5806" transform="translate(4.05078 2.70966)" fill="transparent" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7416 3.28904C12.7416 2.96906 13.001 2.70966 13.3209 2.70966C13.6409 2.70966 13.9003 2.96906 13.9003 3.28904V5.03224H12.7416V3.28904ZM13.9003 18.9677V20.7109C13.9003 21.0309 13.6409 21.2903 13.3209 21.2903C13.001 21.2903 12.7416 21.0309 12.7416 20.7109V18.9677H13.9003ZM4.05078 12C4.05078 12.3207 4.31075 12.5806 4.63143 12.5806H6.36832V11.4193H4.63143C4.31075 11.4193 4.05078 11.6793 4.05078 12ZM20.2736 11.4193H22.0105C22.3312 11.4193 22.5911 11.6793 22.5911 12C22.5911 12.3207 22.3312 12.5806 22.0105 12.5806H20.2736V11.4193ZM6.76593 6.25189C6.53967 6.02513 6.53967 5.65749 6.76593 5.43073C6.9922 5.20398 7.35904 5.20398 7.58531 5.43073L8.81437 6.66247L7.99499 7.48362L6.76593 6.25189ZM17.8275 17.3375L18.6469 16.5163L19.8759 17.7481C20.1022 17.9748 20.1022 18.3425 19.8759 18.5692C19.6497 18.796 19.2828 18.796 19.0566 18.5692L17.8275 17.3375ZM6.76594 18.5692C6.9922 18.796 7.35905 18.796 7.58531 18.5692L8.81437 17.3375L7.995 16.5163L6.76594 17.7481C6.53967 17.9748 6.53967 18.3425 6.76594 18.5692ZM17.8275 6.66246L19.0566 5.43073C19.2828 5.20397 19.6497 5.20397 19.8759 5.43073C20.1022 5.65749 20.1022 6.02513 19.8759 6.25189L18.6469 7.48362L17.8275 6.66246Z"
        fill="currentColor"
      />
      <rect
        x="8.10742"
        y="6.77417"
        width="10.4289"
        height="10.4516"
        rx="5.21447"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M20.2726 10.6934C17.8499 10.6934 15.8789 12.6687 15.8789 15.0966C15.8789 17.5245 17.8499 19.4998 20.2726 19.4998C22.6952 19.4998 24.6663 17.5245 24.6663 15.0966C24.6663 12.6687 22.6952 10.6934 20.2726 10.6934ZM20.695 17.4656H19.8501V16.6189H20.695V17.4656ZM20.6106 16.1127H19.9346L19.8079 12.7256H20.7373L20.6106 16.1127Z"
        fill="#E53E3E"
      />
    </svg>
  ),
  viewBox: '0 0 26 24',
});

export const OfflineIcon = createIcon({
  path: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.522 15.0005C15.5374 14.1234 14.2658 13.639 12.9485 13.639C11.6311 13.639 10.3596 14.1234 9.375 15.0005"
        stroke="#9BA0A1"
        strokeWidth="1.96875"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.3765 12.1408C17.6327 10.5067 15.3344 9.5976 12.947 9.5976C10.5596 9.5976 8.26139 10.5067 6.51758 12.1408"
        stroke="#9BA0A1"
        strokeWidth="1.96875"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21.9152 8.97834C19.4471 6.77181 16.2553 5.55237 12.9478 5.55237C9.64041 5.55237 6.44856 6.77181 3.98047 8.97834"
        stroke="#9BA0A1"
        strokeWidth="1.96875"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15.0246 18.0009L12.9353 20.2977L10.8613 18.0009C11.1098 17.6867 11.4259 17.4329 11.786 17.2584C12.1461 17.084 12.5409 16.9933 12.9409 16.9933C13.3409 16.9933 13.7357 17.084 14.0958 17.2584C14.4559 17.4329 14.772 17.6867 15.0204 18.0009H15.0246Z"
        fill="#9BA0A1"
      />
      <path d="M3.95508 20.5L21.916 3" stroke="#2B2E2D" strokeWidth="2" />
    </svg>
  ),
  viewBox: '0 0 25 24',
});

export const NotificationIcon = createIcon({
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.2497 20.25H3.74968C3.62184 20.2496 3.49621 20.2165 3.38473 20.154C3.27326 20.0914 3.17964 20.0013 3.11276 19.8923C3.04588 19.7834 3.00796 19.6591 3.00261 19.5314C2.99726 19.4037 3.02465 19.2767 3.08218 19.1625C4.00758 17.2973 4.49253 15.2446 4.49968 13.1625V10.5C4.49968 8.51088 5.28986 6.60322 6.69638 5.1967C8.10291 3.79018 10.0106 3 11.9997 3C13.9888 3 15.8965 3.79018 17.303 5.1967C18.7095 6.60322 19.4997 8.51088 19.4997 10.5V13.1475C19.5068 15.2296 19.9918 17.2823 20.9172 19.1475C20.9783 19.2622 21.0085 19.3908 21.0049 19.5207C21.0013 19.6506 20.9641 19.7773 20.8968 19.8885C20.8295 19.9996 20.7344 20.0914 20.621 20.1548C20.5076 20.2181 20.3796 20.251 20.2497 20.25ZM4.91218 18.75H19.0872C18.372 16.9686 18.0029 15.0671 17.9997 13.1475V10.5C17.9997 8.9087 17.3675 7.38258 16.2423 6.25736C15.1171 5.13214 13.591 4.5 11.9997 4.5C10.4084 4.5 8.88226 5.13214 7.75704 6.25736C6.63182 7.38258 5.99968 8.9087 5.99968 10.5V13.1475C5.99648 15.0671 5.62739 16.9686 4.91218 18.75Z"
        fill="currentColor"
      />
      <path
        d="M12 23.25C11.0054 23.25 10.0516 22.8549 9.34835 22.1517C8.64509 21.4484 8.25 20.4946 8.25 19.5C8.25 19.3011 8.32902 19.1103 8.46967 18.9697C8.61032 18.829 8.80109 18.75 9 18.75C9.19891 18.75 9.38968 18.829 9.53033 18.9697C9.67098 19.1103 9.75 19.3011 9.75 19.5C9.75053 20.0965 9.98792 20.6684 10.41 21.09C10.8392 21.4973 11.4083 21.7243 12 21.7243C12.5917 21.7243 13.1608 21.4973 13.59 21.09C13.6599 21.0201 13.7429 20.9646 13.8343 20.9268C13.9257 20.8889 14.0236 20.8694 14.1225 20.8694C14.2214 20.8694 14.3193 20.8889 14.4107 20.9268C14.5021 20.9646 14.5851 21.0201 14.655 21.09C14.7249 21.1599 14.7804 21.2429 14.8182 21.3343C14.8561 21.4257 14.8756 21.5236 14.8756 21.6225C14.8756 21.7214 14.8561 21.8193 14.8182 21.9107C14.7804 22.0021 14.7249 22.0851 14.655 22.155C14.3061 22.503 13.892 22.7788 13.4365 22.9667C12.9809 23.1546 12.4928 23.2509 12 23.25Z"
        fill="currentColor"
      />
      <path
        d="M12 4.5C11.8011 4.5 11.6103 4.42098 11.4697 4.28033C11.329 4.13968 11.25 3.94891 11.25 3.75V1.5C11.25 1.30109 11.329 1.11032 11.4697 0.96967C11.6103 0.829018 11.8011 0.75 12 0.75C12.1989 0.75 12.3897 0.829018 12.5303 0.96967C12.671 1.11032 12.75 1.30109 12.75 1.5V3.75C12.75 3.94891 12.671 4.13968 12.5303 4.28033C12.3897 4.42098 12.1989 4.5 12 4.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 24 24',
});

export const PieIcon = createIcon({
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2188 7.18054C17.6424 8.26504 17.8169 9.43269 17.727 10.5968C17.6275 11.8862 17.2069 13.1302 16.5035 14.2154C15.8001 15.3006 14.8364 16.1926 13.7 16.81C12.6736 17.3677 11.5359 17.6854 10.3723 17.7414L10.3723 10.2432L17.2188 7.18054Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <mask id="path-2-inside-1_1863_62686" fill="white">
        <path d="M7.75005 17.3371C7.79536 17.3463 7.84215 17.3453 7.88704 17.3342C7.93194 17.3232 7.97381 17.3023 8.00964 17.273C8.04548 17.2438 8.07438 17.207 8.09427 17.1653C8.11416 17.1235 8.12454 17.0779 8.12466 17.0316L8.12466 10.0004C8.12497 9.63853 8.22984 9.28445 8.42665 8.98077C8.62347 8.6771 8.90384 8.43676 9.23403 8.28868L15.9711 5.27384C16.0129 5.2552 16.0501 5.22762 16.08 5.19305C16.1099 5.15848 16.1319 5.11776 16.1444 5.07376C16.1569 5.02977 16.1595 4.98357 16.1522 4.93843C16.1449 4.89329 16.1277 4.8503 16.102 4.81251C15.5864 4.05421 14.9464 3.38846 14.209 2.84337C12.812 1.80409 11.1159 1.24522 9.37466 1.2504C4.89458 1.2504 1.24966 4.89532 1.24966 9.3754C1.24966 13.2992 4.04575 16.5824 7.75005 17.3371Z" />
      </mask>
      <path
        d="M7.75005 17.3371C7.79536 17.3463 7.84215 17.3453 7.88704 17.3342C7.93194 17.3232 7.97381 17.3023 8.00964 17.273C8.04548 17.2438 8.07438 17.207 8.09427 17.1653C8.11416 17.1235 8.12454 17.0779 8.12466 17.0316L8.12466 10.0004C8.12497 9.63853 8.22984 9.28445 8.42665 8.98077C8.62347 8.6771 8.90384 8.43676 9.23403 8.28868L15.9711 5.27384C16.0129 5.2552 16.0501 5.22762 16.08 5.19305C16.1099 5.15848 16.1319 5.11776 16.1444 5.07376C16.1569 5.02977 16.1595 4.98357 16.1522 4.93843C16.1449 4.89329 16.1277 4.8503 16.102 4.81251C15.5864 4.05421 14.9464 3.38846 14.209 2.84337C12.812 1.80409 11.1159 1.24522 9.37466 1.2504C4.89458 1.2504 1.24966 4.89532 1.24966 9.3754C1.24966 13.2992 4.04575 16.5824 7.75005 17.3371Z"
        fill="currentColor"
      />
      <path
        d="M7.75005 17.3371L7.35078 19.2969L7.35254 19.2972L7.75005 17.3371ZM8.12466 17.0316L10.1247 17.0367L10.1247 17.0316L8.12466 17.0316ZM8.12466 10.0004L6.12466 9.99868L6.12466 10.0004L8.12466 10.0004ZM9.23403 8.28868L8.4171 6.46313L8.41564 6.46379L9.23403 8.28868ZM15.9711 5.27384L15.1559 3.44755L15.1542 3.44829L15.9711 5.27384ZM16.102 4.81251L14.4481 5.93706L14.4492 5.93872L16.102 4.81251ZM14.209 2.84337L13.0153 4.44806L13.0201 4.45165L14.209 2.84337ZM9.37466 1.2504L9.37466 3.25041L9.38062 3.2504L9.37466 1.2504ZM7.35254 19.2972C7.68788 19.3652 8.03414 19.358 8.36633 19.276L7.40776 15.3925C7.65017 15.3327 7.90284 15.3274 8.14755 15.377L7.35254 19.2972ZM8.36633 19.276C8.69853 19.194 9.00839 19.0393 9.27357 18.823L6.74572 15.723C6.93923 15.5652 7.16535 15.4524 7.40776 15.3925L8.36633 19.276ZM9.27357 18.823C9.53876 18.6068 9.75264 18.3344 9.89981 18.0255L6.28873 16.305C6.39612 16.0796 6.5522 15.8808 6.74572 15.723L9.27357 18.823ZM9.89981 18.0255C10.047 17.7166 10.1238 17.3789 10.1246 17.0367L6.12466 17.0266C6.1253 16.7769 6.18134 16.5304 6.28873 16.305L9.89981 18.0255ZM10.1247 17.0316L10.1247 10.0004L6.12466 10.0004L6.12466 17.0316L10.1247 17.0316ZM10.1247 10.0021C10.1246 10.0257 10.1178 10.0487 10.105 10.0685L6.74831 7.89303C6.34187 8.52016 6.1253 9.25137 6.12466 9.99868L10.1247 10.0021ZM10.105 10.0685C10.0922 10.0883 10.0739 10.1039 10.0524 10.1136L8.41564 6.46379C7.73375 6.76959 7.15476 7.26591 6.74831 7.89303L10.105 10.0685ZM10.051 10.1142L16.7881 7.09939L15.1542 3.44829L8.4171 6.46314L10.051 10.1142ZM16.7864 7.10013C17.0954 6.96218 17.3704 6.75808 17.5919 6.50227L14.5681 3.88383C14.7297 3.69715 14.9304 3.54822 15.1559 3.44755L16.7864 7.10013ZM17.5919 6.50227C17.8135 6.24643 17.9761 5.9451 18.0685 5.61954L14.2203 4.52798C14.2877 4.29041 14.4064 4.07052 14.5681 3.88383L17.5919 6.50227ZM18.0685 5.61954C18.1608 5.29398 18.1806 4.95211 18.1264 4.61807L14.178 5.25878C14.1385 5.01502 14.1529 4.76555 14.2203 4.52798L18.0685 5.61954ZM18.1264 4.61807C18.0722 4.28403 17.9453 3.96596 17.7548 3.6863L14.4492 5.93872C14.3102 5.73465 14.2176 5.50254 14.178 5.25878L18.1264 4.61807ZM17.7559 3.68797C17.1137 2.74339 16.3164 1.91409 15.3979 1.23509L13.0201 4.45165C13.5764 4.86284 14.0592 5.36504 14.4481 5.93706L17.7559 3.68797ZM15.4028 1.23869C13.659 -0.0585005 11.542 -0.756064 9.3687 -0.749587L9.38062 3.2504C10.6897 3.24649 11.9649 3.66668 13.0153 4.44805L15.4028 1.23869ZM9.37466 -0.749596C3.79001 -0.749597 -0.75034 3.79075 -0.750341 9.3754L3.24966 9.3754C3.24966 5.99989 5.99915 3.2504 9.37466 3.2504L9.37466 -0.749596ZM-0.750341 9.3754C-0.750341 14.2702 2.735 18.3565 7.35078 19.2969L8.14931 15.3774C5.3565 14.8084 3.24966 12.3283 3.24966 9.3754L-0.750341 9.3754Z"
        fill="currentColor"
        mask="url(#path-2-inside-1_1863_62686)"
      />
    </svg>
  ),
  viewBox: '0 0 20 20',
});

export const UpsellIcon = createIcon({
  path: (
    <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8065 1.18208C10.864 1.15654 10.9459 1.1219 11.0484 1.08327C11.277 0.997104 11.6009 0.893682 11.9781 0.825099C12.7431 0.686045 13.6484 0.702818 14.447 1.19611L14.447 1.19613C16.0403 2.18023 18.026 1.86709 19.1119 1.58618V6.18891C18.546 6.25477 17.6823 6.32982 16.8041 6.31141C15.849 6.29138 14.9985 6.16148 14.4767 5.88314L14.469 5.87905L14.4612 5.87514C13.5227 5.40218 12.445 5.28381 11.4261 5.54177L10.8602 5.68506V6.26883V10.8095V11.3549L11.3791 11.523C11.7885 11.6556 12.1413 11.9222 12.3806 12.2799L12.3819 12.2818L20.7151 24.6561C20.7537 24.7134 20.776 24.7802 20.7796 24.8493C20.7832 24.9183 20.7679 24.987 20.7354 25.0481C20.7029 25.1091 20.6544 25.1601 20.5951 25.1957C20.5358 25.2313 20.4679 25.25 20.3988 25.25L1.13081 25.2391H1.13077C1.06167 25.2391 0.993879 25.2203 0.934661 25.1847C0.875441 25.1491 0.827019 25.098 0.794582 25.037C0.762145 24.976 0.746913 24.9073 0.750519 24.8383C0.754125 24.7693 0.776431 24.7026 0.815051 24.6453L0.81507 24.6452L5.72249 17.3631C5.93546 17.22 6.24044 17.0706 6.60571 17.0399C7.00274 17.0065 7.56354 17.1047 8.2599 17.6892C9.34146 18.6047 10.7002 19.1287 12.1164 19.1763C12.1272 19.1767 12.1517 19.1777 12.1784 19.1778C12.1789 19.1778 12.1794 19.1778 12.1799 19.1778V18.4278C12.3372 18.4281 12.4884 18.367 12.6013 18.2574C12.7143 18.1479 12.78 17.9986 12.7844 17.8414C12.7889 17.6841 12.7319 17.5313 12.6254 17.4155C12.5189 17.2997 12.3714 17.2301 12.2143 17.2214L10.8065 1.18208ZM10.8065 1.18208L10.7191 1.22782C10.7044 1.23555 10.692 1.24717 10.6833 1.26142C10.6748 1.27556 10.6702 1.29175 10.6701 1.30827V10.8088V11.3545L10.1509 11.5224C9.74125 11.6549 9.38816 11.9215 9.14857 12.2793L9.14737 12.2811L7.69507 14.436C7.89613 14.4774 8.09484 14.5317 8.28996 14.5986C8.93194 14.8186 9.52077 15.1704 10.0187 15.6314L10.8065 1.18208Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
  viewBox: '0 0 22 26',
});
export const UpsellWatchIcon = createIcon({
  path: (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.50012 14.0625C5.747 14.0625 4.09934 13.38 2.85997 12.1402C0.834029 10.1147 0.352622 7.04297 1.66278 4.49766C1.78137 4.2675 2.06356 4.17703 2.29418 4.29516C2.52481 4.41328 2.61528 4.69594 2.49669 4.92656C1.37356 7.10813 1.78606 9.74063 3.52278 11.4773C4.58497 12.54 5.99731 13.125 7.50012 13.125C9.00247 13.125 10.4153 12.54 11.4775 11.4773C12.5397 10.4147 13.1251 9.00234 13.1251 7.5C13.1251 5.99719 12.5401 4.58484 11.4775 3.52266C10.4148 2.46047 9.00293 1.875 7.50012 1.875C5.99731 1.875 4.58497 2.46047 3.52278 3.52266C3.3395 3.70594 3.04325 3.70594 2.85997 3.52266C2.67668 3.33938 2.67668 3.04312 2.85997 2.85984C4.09934 1.62047 5.747 0.9375 7.50012 0.9375C9.25325 0.9375 10.9014 1.62047 12.1403 2.85984C13.3801 4.09922 14.0626 5.74687 14.0626 7.5C14.0626 9.25266 13.3801 10.9008 12.1403 12.1402C10.9014 13.38 9.25325 14.0625 7.50012 14.0625Z"
        fill="currentColor"
      />
      <path
        d="M9.84328 9.84375C9.74062 9.84375 9.6375 9.81047 9.55078 9.74109L7.20703 7.86609C7.09594 7.77703 7.03125 7.6425 7.03125 7.5V3.75C7.03125 3.49125 7.24125 3.28125 7.5 3.28125C7.75875 3.28125 7.96875 3.49125 7.96875 3.75V7.275L10.1367 9.00891C10.3387 9.17109 10.3716 9.46594 10.2098 9.66797C10.117 9.78328 9.98109 9.84375 9.84328 9.84375Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 15 15',
});

export const UpsellActiveIcon = createIcon({
  path: (
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8605 21.6319L11.7177 11.0253C11.4322 10.5987 11.0114 10.2806 10.523 10.1224V6.23046C11.2462 6.04735 12.0112 6.13137 12.6775 6.4671C13.8549 7.09506 16.1141 6.91136 17.1072 6.79103C17.2423 6.7745 17.3667 6.70896 17.4568 6.60685C17.5469 6.50473 17.5964 6.37313 17.5959 6.23696V2.10604C17.5963 2.02032 17.5768 1.93568 17.539 1.85875C17.5012 1.78181 17.4461 1.71465 17.378 1.66252C17.31 1.61038 17.2308 1.57468 17.1467 1.5582C17.0626 1.54173 16.9758 1.54492 16.8931 1.56753C16.0091 1.80901 14.4652 2.05984 13.2924 1.33549C11.5501 0.259294 9.46113 1.33549 9.46113 1.33549V1.34004C9.34471 1.40098 9.24714 1.49256 9.17897 1.6049C9.1108 1.71724 9.07461 1.84607 9.07432 1.97747V10.1219C8.58576 10.2799 8.16466 10.5979 7.87892 11.0245L6.00709 13.8019C6.50126 13.7574 6.99928 13.8175 7.46865 13.9784C7.93802 14.1392 8.3682 14.3973 8.73114 14.7356C9.37564 15.2883 10.1919 15.6003 11.0408 15.6184C11.1755 15.6258 11.3019 15.6855 11.3931 15.7848C11.4844 15.884 11.5333 16.015 11.5295 16.1498C11.5257 16.2846 11.4693 16.4125 11.3726 16.5064C11.2758 16.6003 11.1461 16.6527 11.0113 16.6524C11.0012 16.6524 10.9911 16.652 10.981 16.6516C9.91041 16.6161 8.88317 16.2202 8.06576 15.5279C6.63807 14.3288 5.4829 14.9264 5.00814 15.2843L0.736939 21.6224C0.638669 21.7682 0.581907 21.938 0.572732 22.1136C0.563557 22.2892 0.602313 22.464 0.684851 22.6192C0.76739 22.7745 0.890601 22.9044 1.04129 22.995C1.19199 23.0856 1.36448 23.1335 1.54032 23.1336L18.0557 23.1429C18.2316 23.143 18.4042 23.0952 18.5551 23.0047C18.7059 22.9142 18.8293 22.7844 18.912 22.6291C18.9947 22.4739 19.0336 22.2991 19.0245 22.1234C19.0154 21.9477 18.9587 21.7778 18.8605 21.6319Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 24',
});

export const UsersIcon = createIcon({
  path: (
    <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3801 6.53002C10.3866 7.40058 10.0579 8.24027 9.4622 8.87511C8.86646 9.50994 8.04932 9.89125 7.1801 9.94002C6.31444 9.88632 5.50228 9.50286 4.91076 8.86854C4.31923 8.23423 3.99332 7.39732 4.0001 6.53002C4.0001 5.68132 4.33725 4.86739 4.93736 4.26728C5.53748 3.66716 6.35141 3.33002 7.2001 3.33002C8.0488 3.33002 8.86273 3.66716 9.46285 4.26728C10.063 4.86739 10.4001 5.68132 10.4001 6.53002H10.3801Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7801 17C13.7801 15.2496 13.0847 13.5709 11.847 12.3331C10.6092 11.0954 8.93051 10.4 7.18008 10.4C5.42965 10.4 3.75091 11.0954 2.51317 12.3331C1.27543 13.5709 0.580078 15.2496 0.580078 17H13.7801Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8498 4.53002C20.8563 5.40058 20.5276 6.24027 19.9319 6.87511C19.3362 7.50994 18.519 7.89125 17.6498 7.94002C16.7806 7.89125 15.9634 7.50994 15.3677 6.87511C14.772 6.24027 14.4433 5.40058 14.4498 4.53002C14.4498 4.10979 14.5326 3.69367 14.6934 3.30543C14.8542 2.91719 15.0899 2.56442 15.3871 2.26728C15.6842 1.97013 16.037 1.73442 16.4252 1.5736C16.8135 1.41279 17.2296 1.33002 17.6498 1.33002C18.07 1.33002 18.4861 1.41279 18.8744 1.5736C19.2626 1.73442 19.6154 1.97013 19.9125 2.26728C20.2097 2.56442 20.4454 2.91719 20.6062 3.30543C20.767 3.69367 20.8498 4.10979 20.8498 4.53002V4.53002Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.71 15H24.24C24.245 13.5138 23.7483 12.0695 22.8302 10.9008C21.9122 9.73208 20.6265 8.90743 19.1815 8.56034C17.7364 8.21324 16.2165 8.36403 14.8678 8.98827C13.5191 9.61252 12.4205 10.6737 11.75 12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.5 12.5H23.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  viewBox: '0 0 25 18',
});

export const BusinessIcon = createIcon({
  path: (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2173 21.112C12.0557 21.112 11.9007 21.0478 11.7864 20.9335C11.6722 20.8192 11.608 20.6642 11.608 20.5026V18.7964H10.8296V20.5026C10.8296 20.6642 10.7654 20.8192 10.6511 20.9335C10.5368 21.0478 10.3818 21.112 10.2202 21.112C10.0586 21.112 9.9036 21.0478 9.78932 20.9335C9.67504 20.8192 9.61084 20.6642 9.61084 20.5026V18.187C9.61084 18.0254 9.67504 17.8704 9.78932 17.7561C9.9036 17.6418 10.0586 17.5776 10.2202 17.5776H12.2173C12.379 17.5776 12.534 17.6418 12.6482 17.7561C12.7625 17.8704 12.8267 18.0254 12.8267 18.187V20.5026C12.8267 20.6642 12.7625 20.8192 12.6482 20.9335C12.534 21.0478 12.379 21.112 12.2173 21.112Z"
        fill="#6F6F6F"
      />
      <path
        d="M11.2188 10.5426C11.0571 10.5426 10.9021 10.4784 10.7879 10.3641C10.6736 10.2498 10.6094 10.0948 10.6094 9.9332V9.70001C10.6094 9.5384 10.6736 9.3834 10.7879 9.26912C10.9021 9.15484 11.0571 9.09064 11.2188 9.09064C11.3804 9.09064 11.5354 9.15484 11.6496 9.26912C11.7639 9.3834 11.8281 9.5384 11.8281 9.70001V9.93442C11.8278 10.0958 11.7635 10.2505 11.6492 10.3645C11.535 10.4785 11.3802 10.5426 11.2188 10.5426Z"
        fill="#6F6F6F"
      />
      <path
        d="M14.0625 10.5426C13.9009 10.5426 13.7459 10.4784 13.6316 10.3641C13.5173 10.2498 13.4531 10.0948 13.4531 9.9332V9.70001C13.4531 9.5384 13.5173 9.3834 13.6316 9.26912C13.7459 9.15484 13.9009 9.09064 14.0625 9.09064C14.2241 9.09064 14.3791 9.15484 14.4934 9.26912C14.6077 9.3834 14.6719 9.5384 14.6719 9.70001V9.93442C14.6716 10.0958 14.6072 10.2505 14.493 10.3645C14.3787 10.4785 14.2239 10.5426 14.0625 10.5426Z"
        fill="#6F6F6F"
      />
      <path
        d="M8.375 10.5426C8.21338 10.5426 8.05839 10.4784 7.94411 10.3641C7.82983 10.2498 7.76562 10.0948 7.76562 9.9332V9.70001C7.76562 9.5384 7.82983 9.3834 7.94411 9.26912C8.05839 9.15484 8.21338 9.09064 8.375 9.09064C8.53662 9.09064 8.69161 9.15484 8.80589 9.26912C8.92017 9.3834 8.98438 9.5384 8.98438 9.70001V9.93442C8.98405 10.0958 8.91971 10.2505 8.80546 10.3645C8.69122 10.4785 8.53641 10.5426 8.375 10.5426Z"
        fill="#6F6F6F"
      />
      <path
        d="M8.10889 4.78885C7.94727 4.78885 7.79227 4.72465 7.67799 4.61037C7.56371 4.49609 7.49951 4.34109 7.49951 4.17947V3.94507C7.49951 3.78345 7.56371 3.62846 7.67799 3.51418C7.79227 3.3999 7.94727 3.33569 8.10889 3.33569C8.2705 3.33569 8.4255 3.3999 8.53978 3.51418C8.65406 3.62846 8.71826 3.78345 8.71826 3.94507V4.17947C8.71826 4.34109 8.65406 4.49609 8.53978 4.61037C8.4255 4.72465 8.2705 4.78885 8.10889 4.78885Z"
        fill="#6F6F6F"
      />
      <path
        d="M5.26514 4.78885C5.10352 4.78885 4.94852 4.72465 4.83424 4.61037C4.71996 4.49609 4.65576 4.34109 4.65576 4.17947V3.94507C4.65576 3.78345 4.71996 3.62846 4.83424 3.51418C4.94852 3.3999 5.10352 3.33569 5.26514 3.33569C5.42675 3.33569 5.58175 3.3999 5.69603 3.51418C5.81031 3.62846 5.87451 3.78345 5.87451 3.94507V4.17947C5.87451 4.34109 5.81031 4.49609 5.69603 4.61037C5.58175 4.72465 5.42675 4.78885 5.26514 4.78885Z"
        fill="#6F6F6F"
      />
      <path
        d="M11.2188 13.3156C11.0571 13.3156 10.9021 13.2514 10.7879 13.1372C10.6736 13.0229 10.6094 12.8679 10.6094 12.7063V12.4719C10.6094 12.3102 10.6736 12.1552 10.7879 12.041C10.9021 11.9267 11.0571 11.8625 11.2188 11.8625C11.3804 11.8625 11.5354 11.9267 11.6496 12.041C11.7639 12.1552 11.8281 12.3102 11.8281 12.4719V12.7063C11.8281 12.8679 11.7639 13.0229 11.6496 13.1372C11.5354 13.2514 11.3804 13.3156 11.2188 13.3156Z"
        fill="#6F6F6F"
      />
      <path
        d="M14.0625 13.3156C13.9009 13.3156 13.7459 13.2514 13.6316 13.1372C13.5173 13.0229 13.4531 12.8679 13.4531 12.7063V12.4719C13.4531 12.3102 13.5173 12.1552 13.6316 12.041C13.7459 11.9267 13.9009 11.8625 14.0625 11.8625C14.2241 11.8625 14.3791 11.9267 14.4934 12.041C14.6077 12.1552 14.6719 12.3102 14.6719 12.4719V12.7063C14.6719 12.8679 14.6077 13.0229 14.4934 13.1372C14.3791 13.2514 14.2241 13.3156 14.0625 13.3156Z"
        fill="#6F6F6F"
      />
      <path
        d="M8.375 13.3156C8.21338 13.3156 8.05839 13.2514 7.94411 13.1372C7.82983 13.0229 7.76562 12.8679 7.76562 12.7063V12.4719C7.76562 12.3102 7.82983 12.1552 7.94411 12.041C8.05839 11.9267 8.21338 11.8625 8.375 11.8625C8.53662 11.8625 8.69161 11.9267 8.80589 12.041C8.92017 12.1552 8.98438 12.3102 8.98438 12.4719V12.7063C8.98438 12.8679 8.92017 13.0229 8.80589 13.1372C8.69161 13.2514 8.53662 13.3156 8.375 13.3156Z"
        fill="#6F6F6F"
      />
      <path
        d="M11.2188 16.0875C11.0571 16.0875 10.9021 16.0233 10.7879 15.909C10.6736 15.7948 10.6094 15.6398 10.6094 15.4781V15.2441C10.6094 15.0825 10.6736 14.9275 10.7879 14.8132C10.9021 14.699 11.0571 14.6348 11.2188 14.6348C11.3804 14.6348 11.5354 14.699 11.6496 14.8132C11.7639 14.9275 11.8281 15.0825 11.8281 15.2441V15.4781C11.8281 15.6398 11.7639 15.7948 11.6496 15.909C11.5354 16.0233 11.3804 16.0875 11.2188 16.0875Z"
        fill="#6F6F6F"
      />
      <path
        d="M14.0625 16.0875C13.9009 16.0875 13.7459 16.0233 13.6316 15.909C13.5173 15.7948 13.4531 15.6398 13.4531 15.4781V15.2441C13.4531 15.0825 13.5173 14.9275 13.6316 14.8132C13.7459 14.699 13.9009 14.6348 14.0625 14.6348C14.2241 14.6348 14.3791 14.699 14.4934 14.8132C14.6077 14.9275 14.6719 15.0825 14.6719 15.2441V15.4781C14.6719 15.6398 14.6077 15.7948 14.4934 15.909C14.3791 16.0233 14.2241 16.0875 14.0625 16.0875Z"
        fill="#6F6F6F"
      />
      <path
        d="M8.375 16.0875C8.21338 16.0875 8.05839 16.0233 7.94411 15.909C7.82983 15.7948 7.76562 15.6398 7.76562 15.4781V15.2441C7.76562 15.0825 7.82983 14.9275 7.94411 14.8132C8.05839 14.699 8.21338 14.6348 8.375 14.6348C8.53662 14.6348 8.69161 14.699 8.80589 14.8132C8.92017 14.9275 8.98438 15.0825 8.98438 15.2441V15.4781C8.98438 15.6398 8.92017 15.7948 8.80589 15.909C8.69161 16.0233 8.53662 16.0875 8.375 16.0875Z"
        fill="#6F6F6F"
      />
      <path
        d="M19.2826 21.4687H0.717773C0.556157 21.4687 0.40116 21.4045 0.28688 21.2902C0.1726 21.1759 0.108398 21.0209 0.108398 20.8593C0.108398 20.6977 0.1726 20.5427 0.28688 20.4284C0.40116 20.3141 0.556157 20.2499 0.717773 20.2499H19.2834C19.445 20.2499 19.6 20.3141 19.7143 20.4284C19.8286 20.5427 19.8928 20.6977 19.8928 20.8593C19.8928 21.0209 19.8286 21.1759 19.7143 21.2902C19.6 21.4045 19.445 21.4687 19.2834 21.4687H19.2826Z"
        fill="currentColor"
      />
      <path
        d="M17.1833 21.4687C17.0217 21.4687 16.8667 21.4045 16.7524 21.2902C16.6381 21.1759 16.5739 21.0209 16.5739 20.8593V7.3653H12.9863C12.8247 7.3653 12.6697 7.30109 12.5554 7.18681C12.4412 7.07253 12.377 6.91754 12.377 6.75592C12.377 6.5943 12.4412 6.43931 12.5554 6.32503C12.6697 6.21075 12.8247 6.14655 12.9863 6.14655H17.1833C17.3449 6.14655 17.4999 6.21075 17.6142 6.32503C17.7285 6.43931 17.7927 6.5943 17.7927 6.75592V20.8593C17.7927 21.0209 17.7285 21.1759 17.6142 21.2902C17.4999 21.4045 17.3449 21.4687 17.1833 21.4687Z"
        fill="currentColor"
      />
      <path
        d="M5.25439 19.4374C5.09278 19.4374 4.93778 19.3732 4.8235 19.2589C4.70922 19.1447 4.64502 18.9897 4.64502 18.828V6.75592C4.64502 6.5943 4.70922 6.43931 4.8235 6.32503C4.93778 6.21075 5.09278 6.14655 5.25439 6.14655H10.7038C10.8654 6.14655 11.0204 6.21075 11.1347 6.32503C11.249 6.43931 11.3132 6.5943 11.3132 6.75592C11.3132 6.91754 11.249 7.07253 11.1347 7.18681C11.0204 7.30109 10.8654 7.3653 10.7038 7.3653H5.86377V18.828C5.86377 18.9897 5.79957 19.1447 5.68529 19.2589C5.57101 19.3732 5.41601 19.4374 5.25439 19.4374Z"
        fill="currentColor"
      />
      <path
        d="M2.66943 21.4687C2.50782 21.4687 2.35282 21.4045 2.23854 21.2902C2.12426 21.1759 2.06006 21.0209 2.06006 20.8593V1.14075C2.06006 0.979131 2.12426 0.824134 2.23854 0.709854C2.35282 0.595574 2.50782 0.531372 2.66943 0.531372H10.7038C10.8655 0.531372 11.0205 0.595574 11.1347 0.709854C11.249 0.824134 11.3132 0.979131 11.3132 1.14075V6.75593C11.3132 6.91755 11.249 7.07255 11.1347 7.18683C11.0205 7.30111 10.8655 7.36531 10.7038 7.36531C10.5422 7.36531 10.3872 7.30111 10.2729 7.18683C10.1587 7.07255 10.0945 6.91755 10.0945 6.75593V1.75012H3.27881V20.8593C3.27881 21.0209 3.21461 21.1759 3.10033 21.2902C2.98605 21.4045 2.83105 21.4687 2.66943 21.4687Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 22',
});

export const PhoneIcon = createIcon({
  path: (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.18373 9.57479C8.03166 9.57479 7.87958 9.52187 7.76374 9.41656L5.28592 7.16454C5.17424 7.06301 5.11186 6.92584 5.11186 6.78272C5.11186 6.63961 5.17424 6.50189 5.28592 6.4009L6.73186 5.08696C7.18334 4.67652 7.18334 4.00847 6.73186 3.59803L5.08038 2.09669C4.64256 1.69921 3.87979 1.69867 3.44197 2.09669C3.41583 2.12045 3.38672 2.14205 3.35583 2.1615C3.28751 2.2047 1.6295 3.28264 1.90158 5.50874C1.93782 5.80523 1.70316 6.07201 1.37703 6.10496C1.05386 6.13898 0.757423 5.92458 0.721186 5.62809C0.392078 2.93971 2.29484 1.53071 2.63821 1.30011C3.52751 0.524598 5.04473 0.537559 5.91978 1.33252L7.57126 2.83386C8.48611 3.66554 8.48611 5.01837 7.57126 5.85005L6.54651 6.78272L8.60373 8.65292C8.83601 8.86408 8.83601 9.2054 8.60373 9.41656C8.48789 9.52241 8.33581 9.57479 8.18373 9.57479Z"
        fill="currentColor"
      />
      <path
        d="M5.29314 12.2027C5.14106 12.2027 4.98899 12.1498 4.87314 12.0445C3.41355 10.7176 2.32107 9.42252 1.62543 8.19498C1.47514 7.92981 1.58979 7.60416 1.88147 7.46753C2.17434 7.33089 2.53137 7.43566 2.68167 7.70029C3.32087 8.82846 4.34027 10.0333 5.71314 11.2808C5.94542 11.492 5.94542 11.8333 5.71314 12.0445C5.59671 12.1503 5.44522 12.2027 5.29314 12.2027Z"
        fill="currentColor"
      />
      <path
        d="M12.5593 15.8297C10.2205 15.8297 7.62924 14.5503 4.84608 12.0196C4.61381 11.8085 4.61381 11.4672 4.84608 11.256C5.07836 11.0448 5.4538 11.0448 5.68608 11.256C8.38251 13.7078 10.9007 14.9078 12.9835 14.7318C14.8191 14.5741 15.709 13.4114 15.7179 13.3989C15.7387 13.3709 15.7625 13.3444 15.7892 13.3206C16.0078 13.1224 16.1284 12.8573 16.1284 12.5764C16.1284 12.2956 16.0078 12.031 15.7892 11.8322L14.1377 10.3304C13.9191 10.1316 13.628 10.0225 13.3179 10.0225C13.0084 10.0225 12.7179 10.1316 12.4999 10.3304L11.0534 11.6443C10.8211 11.8555 10.4457 11.8555 10.2134 11.6443L7.73676 9.39283C7.50449 9.18167 7.50449 8.84036 7.73676 8.6292C7.96904 8.41804 8.34449 8.41804 8.57676 8.6292L10.6334 10.4989L11.6593 9.56673C12.1019 9.16385 12.6906 8.94189 13.3179 8.94189C13.9453 8.94189 14.5346 9.16385 14.9777 9.56619L16.6292 11.0686C17.0724 11.4709 17.3165 12.0067 17.3165 12.5764C17.3165 13.1305 17.0854 13.6528 16.6649 14.0513C16.4486 14.317 15.2825 15.6191 13.0952 15.807C12.9187 15.8227 12.7393 15.8297 12.5593 15.8297Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 18 16',
});

export const EmailIcon = createIcon({
  path: (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.833252 4.26851V11.9167C0.833252 12.1928 1.05711 12.4167 1.33325 12.4167H18.6666C18.9427 12.4167 19.1666 12.1928 19.1666 11.9167V4.26851M17.6303 1.41666H2.42888C1.93916 1.41666 1.74139 2.04777 2.14355 2.32724L9.92102 7.7322C10.0959 7.85371 10.3285 7.85116 10.5006 7.72583L17.9246 2.32088C18.316 2.03594 18.1144 1.41666 17.6303 1.41666Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 20 14',
});
// eslint-enable max-len
